import { Col, message, Row } from 'antd'
import { Icon, Button, Switcher } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import MultiSelectDropdown from '../Dropdown/MultiSelectDropdown'
import { getBusinessUnitsBySector, getCategoriesBySectorAndBusinessUnit, getCategoriesLevel1, getSectors, getCategoriesLevel2, getRoles, formatUserDataForVendorListApi, formatUserDataForVendorListApiwithCountry, getCategoriesL0ForSPM, getCategoriesL1ForSPM, getCategoriesL2ForSPM, getCategoriesL2ForSmartcube, getCategoriesL1ForSmartcube, changeFromDateOptionsUtil, changeToDateOptionsUtil, getSectorsV2, getBusinessUnitsBySectorV2, getCountriesBySectorBuV2, getCategoryL0ListV2, getCategoryL1ListV2, getCategoryL2ListV2 } from '../../pages/KPIOverview/KpiUtils'
import SingleSelectDropdown from '../Dropdown/SingleSelectDropdown'
import { useDispatch, useSelector } from 'react-redux'
import { FetchSpendDetailAction } from '../../redux/action/SpendModalAction'
import { FetchSupplierPerfDetail } from '../../redux/action/SupplierPerfAction'
import { FetchArchletDetailAction, FetchContractDetailAction, FetchArchletDropdownAction, FetchAribaDropdownAction, FetchAribaKpiAction } from '../../redux/action/ContractAction'
import { FetchMarketIntelDetailAction, FetchSmartCubeCategoryAction, FetchMarketIntelInHouseDetailAction } from '../../redux/action/MarketIntelAction'
import { appNames } from '../../constants/appNames'
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from '../../constants/localStoreKeys';
import { getMonthsWithYear, getToDateOptions, getMonthsWithYearRange, calculateMonthDifference, formatIntoDropdownData, getMonthsWithYearRangeAdjustedForMaxDate, getToDateOptionsWithMaxDate, getMonthsWithYearWithMaxDate, generateMonthsList, getFromDateMonth, getOverlappingOptions } from '../../utils/utils';
import { allCategoryL0 } from '../../mocks/userJson.js';
import { FetchCompassCoverageReportChartAction, FetchCompassDetailAction, FetchCompassDropdownAction, FetchCompassDropdownV2Action, FetchCompassExecutiveSummaryAction, FetchCompasskpiPageHeaderAction, FetchCompassSectorBuChartAction, FetchCompassSectorCategoryChartAction } from '../../redux/action/CommodityBuyPlanAction';
import InfoIcon from "../Icons/InfoIcon.js";
import { useToast } from '../../components/Toast/ToastContext';
import { FetchPowerSteeringKpiAction } from '../../redux/action/SavingsReportingAction.js'
import { FetchForeStreetKpiAction } from '../../redux/action/ForestreetAction.js'
import { FetchSCMKpiAction } from '../../redux/action/SCMAction.js'
import { FetchVeridionKpiAction } from '../../redux/action/VeridionAction.js'
import reset_icon from "../../../src/assets/reset_icon.svg";
import { FetchMyRISDropdownAction,FetchMyRISDetailAction } from '../../redux/action/MyRISAction.js'




const coManL0Category = [{ displayText: appNames.coman, id: 1 }];
const defaultYear = window.YEAR
const VERIDION_DEFAULT_YEAR = 2025

function ModalFilters({ modalName, selectedYear, capability, userData, userDataV2, onParentCallback = () => { }, landingPageFilters, setLoader, appName = "", getSelectedYear, selectedTab=-1, countrySwitcherIndex=0, isModalOpen=true, compassFilterSnapshot, onCompassFilterSnapshotChange }) {

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dispatch = useDispatch()
    const [roleSelected, setRoleSelected] = useState([])
    const [sectorSelected, setSectorSelected] = useState([])
    const [businessUnitSelected, setBusinessUnitSelected] = useState([])
    const [countriesSelected, setCountriesSelected] = useState([])
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const [categoryL2Selected, setCategoryL2Selected] = useState([])
    const [fromDateSelected, setFromDateSelected] = useState("")
    const [toDateSelected, setToDateSelected] = useState("")
    const [sectors, setSectors] = useState([])
    const [businessUnits, setBusinessUnits] = useState([])
    const [countries, setCountries] = useState([])
    const [categoriesLevel0, setCategoriesLevel0] = useState([])
    const [categoriesLevel1, setCategoriesLevel1] = useState([])
    const [categoriesLevel2, setCategoriesLevel2] = useState([])
    const [userInfoByRole, setUserInfoByRole] = useState({})
    const [spendDetailsData, setSpendDetailsData] = useState({})
    const [allRoles, setAllRoles] = useState([])
    const [fromDates, setFromDates] = useState([])
    const [toDates, setToDates] = useState([])
    const [entireMonthList, setEntireMonthList] = useState([])
    const [apiLoader, setApiLoader] = useState(true)
    const [blankL0Categories, setBlankL0Categories] = useState([])
    const [blankL1Categories, setBlankL1Categories] = useState([])
    const [selectedBlankL0Categories, setSelectedBlankL0Categories] = useState([])
    const [selectedBlankL1Categories, setSelectedBlankL1Categories] = useState([])
    const [monthYearDate, setMonthYearDate] = useState([])
    const [userAccessibleSectorList, setUserAccessibleSectorList] = useState([])
    const [compassMonthList, setCompassMonthList] = useState([])
    const [yearsDropdown, setYearsDropdown] = useState([])
    const [dropdownValues, setDropdownValues] = useState({}) 
    const compassModeRef = useRef(countrySwitcherIndex);
    const compassFilterSnapshotReady = useRef(false);
    const isCompassModal = capability === appNames.compass && modalName === "Compass";

    const selectSavedOptions = (options, savedOptions, fallbackOptions = []) => {
        const selections = Array.isArray(savedOptions) ? savedOptions : fallbackOptions;
        return getOverlappingOptions(options || [], selections || []);
    };

    const spendAnalyticsDetailViewData = useSelector((state) => state.getSpendDetailReducer);
    const supplierPerfDetail = useSelector((state) => state.GetSupplierPerfReducer);
    const contractDetail = useSelector((state) => state.getContractDetailReducer);
    const marketIntelDetail = useSelector((state) => state.getMarketIntelDetailReducer);
    const smartcubeCategories = useSelector((state) => state.getSmartCubeCategoryReducer);
    const archletDetailViewData = useSelector((state) => state.getArchletDetailReducer);
    const scmDetailViewData = useSelector((state) => state.getSCMKpiReducer);
    const compassDetailViewData = useSelector((state) => state.getCompassDetailReducer);
    const compassKpiPageHeaderData = useSelector((state) => state.getCompassKpiPageHeaderReducer);
    const compassSectorBuChartData = useSelector((state) => state.getCompassSectorBuChartReducer);
    const compassSectorCategoryChartData = useSelector((state) => state.getCompassSectorCategoryChartReducer);
    const compassCoverageReportChartData = useSelector((state) => state.getCompassCoverageReportChartReducer);
    const compassExecutiveSummaryData = useSelector((state) => state.getCompassExecutiveSummaryReducer);
    const powerSteeringDetailViewData = useSelector((state) => state.getPowerSteeringKpiReducer);
    const foreStreetDetailViewData = useSelector((state) => state.getForeStreetKpiReducer);
    const veridionDetailViewData = useSelector((state) => state.getVeridionKpiReducer);
    const aribaDetailViewData = useSelector((state) => state.getAribaKpiReducer);
    const userAccessibleSectors = useSelector((state) => state?.localData?.data[localStoreKeys.accessibleUserSectors]);
    const maxDateForApps = useSelector((state) => state?.localData?.data[localStoreKeys.maxDateForApps]);
    const archletDropdownData = useSelector((state) => state.getArchletDropdownReducer);
    const aribaDropdownData = useSelector((state) => state.getAribaDropdownReducer);
    const myRISDropdownData = useSelector((state) => state.getMyRISDropdownReducer);
    const myRISDetailViewData = useSelector((state) => state.getMyRISDetailReducer);
    const compassDropdownData = useSelector((state) => state.getCompassDropdownReducer);
    const compassV2DropdownData = useSelector((state) => state.getCompassDropdownV2Reducer);
    const monthDiff = calculateMonthDifference(fromDateSelected?.[0]?.['displayText'], toDateSelected?.[0]?.['displayText'])
    let currentController = null;
    const { showToast } = useToast();

    useEffect(() => {
        if (!isCompassModal || !isModalOpen) return;

        if (compassModeRef.current !== countrySwitcherIndex) {
            compassModeRef.current = countrySwitcherIndex;
            compassFilterSnapshotReady.current = false;
            return;
        }

        if (compassFilterSnapshotReady.current && onCompassFilterSnapshotChange) {
            onCompassFilterSnapshotChange(countrySwitcherIndex, {
                role: roleSelected,
                sectors: sectorSelected,
                businessUnits: businessUnitSelected,
                countries: countriesSelected,
                categoryL0: categoryL0Selected,
                categoryL1: categoryL1Selected,
                categoryL2: categoryL2Selected,
                fromDateSelected
            });
        }
    }, [
        isCompassModal,
        isModalOpen,
        countrySwitcherIndex,
        roleSelected,
        sectorSelected,
        businessUnitSelected,
        countriesSelected,
        categoryL0Selected,
        categoryL1Selected,
        categoryL2Selected,
        fromDateSelected,
        onCompassFilterSnapshotChange
    ]);

    useEffect(() => {
        if (!isCompassModal || isModalOpen) return;
        compassFilterSnapshotReady.current = false;
        compassModeRef.current = countrySwitcherIndex;
    }, [isCompassModal, isModalOpen, countrySwitcherIndex]);

    
    useEffect(() => {
        if (spendAnalyticsDetailViewData?.type === "SUCCESS_SPEND_DETAIL_VIEW_ACTION") {
            setSpendDetailsData(spendAnalyticsDetailViewData)
            const dataForSpendModal = {
                spendData: spendAnalyticsDetailViewData,
                BU: businessUnitSelected,
                categoriesLevel0: categoryL0Selected,
                categoriesLevel1: categoryL1Selected,
                categoriesLevel2: categoryL2Selected,
                loader: apiLoader,
                monthDiff: monthDiff
            }
            onParentCallback(dataForSpendModal)
        }
    }, [spendAnalyticsDetailViewData])

    
    useEffect(() => {
        if (supplierPerfDetail && supplierPerfDetail.type === "SUCCESS_COMAN_ACTION") {
            onParentCallback({ data: supplierPerfDetail, loader: apiLoader, monthDiff })
        }
    }, [supplierPerfDetail])
    
    useEffect(() => {
        if (modalName == "Contract" && contractDetail && contractDetail.type === "SUCCESS_CONTRACT_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: contractDetail, loader: apiLoader, monthDiff, modalName: modalName })
        }
    }, [contractDetail])
    
    useEffect(() => {
        if (marketIntelDetail && marketIntelDetail.type === "SUCCESS_MARKET_INTEL_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: marketIntelDetail, loader: apiLoader, monthDiff })
        }
    }, [marketIntelDetail])
    
    useEffect(() => {
        if (modalName == "Archlet" && archletDetailViewData && archletDetailViewData.type === "SUCCESS_ARCHLET_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: archletDetailViewData, loader: apiLoader, monthDiff, modalName: modalName })
        }
    }, [archletDetailViewData])
    
    useEffect(() => {
        if (modalName == "myRIS" && myRISDetailViewData && myRISDetailViewData.type === "SUCCESS_MYRIS_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: myRISDetailViewData, loader: apiLoader, monthDiff, modalName: modalName })
        }
    }, [myRISDetailViewData])
    
    useEffect(() => {
        if (modalName == "Should Cost Modelling" && scmDetailViewData && scmDetailViewData.type === "SUCCESS_SCM_DETAIL_VIEW_ACTION") {
            
            onParentCallback({ data: scmDetailViewData, loader: apiLoader, monthDiff, modalName: modalName })
        }
    }, [scmDetailViewData])
    
    // useEffect(() => {
    //     if (modalName == "Compass" && compassDetailViewData && compassDetailViewData.type === "SUCCESS_COMPASS_DETAIL_VIEW_ACTION") {
    //         onParentCallback({ data: compassDetailViewData, loader: apiLoader, monthDiff, fromDateSelected: fromDateSelected, modalName: modalName })
    //     }
    //     if (modalName == "Compass" && compassKpiPageHeaderData && compassKpiPageHeaderData.type === "SUCCESS_COMPASS_KPI_PAGE_HEADER_ACTION") {
    //         onParentCallback({ data: compassKpiPageHeaderData, loader: apiLoader, monthDiff, fromDateSelected: fromDateSelected, modalName: modalName })
    //     }
    //     if (modalName == "Compass" && compassSectorBuChartData && compassSectorBuChartData.type === "SUCCESS_COMPASS_SECTOR_BU_CHART_ACTION") {
    //         onParentCallback({ data: compassSectorBuChartData, loader: apiLoader, monthDiff, fromDateSelected: fromDateSelected, modalName: modalName })
    //     }
    //     if (modalName == "Compass" && compassSectorCategoryChartData && compassSectorCategoryChartData.type === "SUCCESS_COMPASS_SECTOR_CATEGORY_CHART_ACTION") {
    //         onParentCallback({ data: compassSectorCategoryChartData, loader: apiLoader, monthDiff, fromDateSelected: fromDateSelected, modalName: modalName })
    //     }
    //     if (modalName == "Compass" && compassCoverageReportChartData && compassCoverageReportChartData.type === "SUCCESS_COMPASS_COVERAGE_REPORT_CHART_ACTION") {
    //         onParentCallback({ data: compassCoverageReportChartData, loader: apiLoader, monthDiff, fromDateSelected: fromDateSelected, modalName: modalName })
    //     }
    //     if (modalName == "Compass" && compassExecutiveSummaryData && compassExecutiveSummaryData.type === "SUCCESS_COMPASS_EXECUTIVE_SUMMARY_ACTION") {
    //         onParentCallback({ data: compassExecutiveSummaryData, loader: apiLoader, monthDiff, fromDateSelected: fromDateSelected, modalName: modalName })
    //     }
    // }, [compassDetailViewData, compassKpiPageHeaderData, compassSectorBuChartData, compassSectorCategoryChartData, compassCoverageReportChartData, compassExecutiveSummaryData])
    
    useEffect(() => {
        if (modalName == "PowerSteering" && powerSteeringDetailViewData && powerSteeringDetailViewData.type === "SUCCESS_POWERSTEERING_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: powerSteeringDetailViewData, loader: apiLoader, fromDateSelected: fromDateSelected, modalName: modalName })
        }
    }, [powerSteeringDetailViewData])
    //foreStreetDetailViewData
    
    useEffect(() => {
        if (modalName == "ForeStreet" && foreStreetDetailViewData && foreStreetDetailViewData.type === "SUCCESS_FORESTREET_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: foreStreetDetailViewData, loader: apiLoader, fromDateSelected: fromDateSelected , modalName: modalName })
        }
    }, [foreStreetDetailViewData])
    
    useEffect(() => {
        if (modalName == "Veridion" && veridionDetailViewData && veridionDetailViewData.type === "SUCCESS_VERIDION_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: veridionDetailViewData, loader: apiLoader, fromDateSelected: fromDateSelected , modalName: modalName })
        }
    }, [veridionDetailViewData])
    
    useEffect(() => {
        if (modalName == "Ariba" && aribaDetailViewData && aribaDetailViewData.type === "SUCCESS_ARIBA_DETAIL_VIEW_ACTION") {
            onParentCallback({ data: aribaDetailViewData, loader: apiLoader, monthDiff, modalName: modalName })
        }
    }, [aribaDetailViewData])
    
    useEffect(() => {
        if (modalName == "SmartCube" && smartcubeCategories && smartcubeCategories.type === "SUCCESS_SMARTCUBE_CATEGORY_ACTION") {
            const sectorsToInclude = landingPageFilters?.allSectors?.map(i => i.displayText)
            const defaultRole = landingPageFilters?.role?.[0]?.['displayText']
            const roleDetails = smartcubeCategories?.data?.filter(item => defaultRole === item.role);
            if (roleDetails?.length > 0) {
                let tempCategoriesL0 = getCategoriesL0ForSPM(roleDetails[0]?.l0)
                let tempCategoriesL1 = getCategoriesL1ForSPM(roleDetails[0]?.l0)
                // let tempCategoriesL2 = getCategoriesL2ForSPM(roleDetails[0]?.l0)

                let tempCategoriesL0Selected = getCategoriesL0ForSPM(roleDetails[0]?.l0)
                let tempCategoriesL0Selected_array = landingPageFilters?.l0sSelected?.map(i => i.displayText)
                let tempCategoriesL0Selected_formatted = formatIntoDropdownData(tempCategoriesL0Selected_array, tempCategoriesL0)
                setCategoriesLevel0(tempCategoriesL0)
                setCategoryL0Selected(tempCategoriesL0Selected_formatted)
                ////
                localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategoriesL0Selected_formatted))
                let tempCategoriesL1Selected_array = landingPageFilters?.l1sSelected?.map(i => i.displayText)
                let tempCategoriesL1Selected_formatted = formatIntoDropdownData(tempCategoriesL1Selected_array, tempCategoriesL1)
                setCategoriesLevel1(tempCategoriesL1)
                setCategoryL1Selected(tempCategoriesL1Selected_formatted)
                localStorage.setItem('categoryL1Selected', JSON.stringify(tempCategoriesL1Selected_formatted))
                let tempCategoriesL2 = getCategoriesL2ForSmartcube(roleDetails[0]?.l0, tempCategoriesL0Selected_array, tempCategoriesL1Selected_array)


                setCategoriesLevel2(tempCategoriesL2)
                setCategoryL2Selected(tempCategoriesL2)
                localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesL2))
                spendCardApiCallonChange(landingPageFilters?.role, landingPageFilters?.sectors, landingPageFilters?.bus, landingPageFilters?.l0sSelected, landingPageFilters?.l1sSelected, tempCategoriesL2, "", "", sectorsToInclude, 18)
            }
        }
    }, [smartcubeCategories])
    
    useEffect(() => {
        const blankCategories = JSON.parse(localStorage.getItem("blankCategories"));
        if (blankCategories) {
            const categoriesArray = Object.keys(blankCategories)
                ?.filter(key => key !== "type")
                ?.map(key => blankCategories[key]);
            if (capability === appNames.contract) {
                const app = categoriesArray.find(item => item.appName === "Contract");
                setBlankL0Categories(app.l0List)
                setBlankL1Categories(app.l1List)
            }
        }
    }, [])
    
    useEffect(() => {
        const displayTexts = categoryL0Selected?.map(item => item?.displayText);
        const matchingL0Categories = blankL0Categories.filter(item => displayTexts.includes(item));
        setSelectedBlankL0Categories(matchingL0Categories);
    }, [categoryL0Selected])
    
    useEffect(() => {
        const displayTexts = categoryL1Selected?.map(item => item?.displayText);
        const matchingL1Categories = blankL1Categories.filter(item => displayTexts.includes(item));
        setSelectedBlankL1Categories(matchingL1Categories);
    }, [categoryL1Selected])
    
    useEffect(() => {
        if (landingPageFilters && capability!==appNames.archlet) {
        // if (landingPageFilters) {
            // console.log("landingPageFilters", landingPageFilters);
            setRoleSelected(landingPageFilters?.role)
            localStorage.setItem("roleSelected", JSON.stringify(landingPageFilters?.role))
            setSectorSelected(landingPageFilters?.sectors)
            localStorage.setItem("sectorSelected", JSON.stringify(landingPageFilters?.sectors))
            dispatch(setKeyValue({ key: localStoreKeys.sectorSelectedOnDetail, value: landingPageFilters?.sectors }))

            setBusinessUnitSelected(landingPageFilters?.bus)
            localStorage.setItem('BUSeleceted', JSON.stringify(landingPageFilters?.bus))
            setCategoryL0Selected(landingPageFilters?.l0sSelected)
            ////
            localStorage.setItem('CategoryL0Selected', JSON.stringify(landingPageFilters?.l0sSelected))
            setCategoryL1Selected(landingPageFilters?.l1sSelected)
            localStorage.setItem('categoryL1Selected', JSON.stringify(landingPageFilters?.l1sSelected))
            setCategoryL2Selected(landingPageFilters?.l2sSelected)
            localStorage.setItem('categoryL2Selected', JSON.stringify(landingPageFilters?.l2sSelected))
            setMonthYearDate(landingPageFilters?.year)
            // setCategoriesLevel1(landingPageFilters?.l1s)
        }
    }, [landingPageFilters]); 
    
    useEffect(() => {
        if (capability===appNames.archlet && appName==="Archlet" && archletDropdownData && archletDropdownData.type === "SUCCESS_ARCHLET_DROPDOWN_ACTION") {
                const dropdownData = archletDropdownData;
                setDropdownValues(dropdownData)
                assignDropdownValues(dropdownData);
        }
    }, [archletDropdownData]);
    
    useEffect(() => {
        if (capability===appNames.archlet && appName==="SAP Ariba" && aribaDropdownData && aribaDropdownData.type === "SUCCESS_ARIBA_DROPDOWN_ACTION") {
                const dropdownData = aribaDropdownData;
                setDropdownValues(dropdownData)
                assignDropdownValues(dropdownData);
        }
    }, [aribaDropdownData]);
    
    useEffect(() => {
        if (capability===appNames.r2pInsights && myRISDropdownData && myRISDropdownData.type === "SUCCESS_MYRIS_DROPDOWN_ACTION") {
                const dropdownData = myRISDropdownData;
                setDropdownValues(dropdownData)
                assignDropdownValues(dropdownData);
        }
    }, [myRISDropdownData]);
    
    useEffect(() => {
        if (isModalOpen && capability === appNames.compass && countrySwitcherIndex === 0 && compassDropdownData && compassDropdownData?.type === "SUCCESS_COMPASS_DROPDOWN_ACTION") {
                const dropdownData = compassDropdownData?.data;              
                setDropdownValues(dropdownData)
                assignCompassDropdownValues(0, dropdownData);
        }
    }, [compassDropdownData, isModalOpen, capability, countrySwitcherIndex]);
    
    useEffect(() => {
        if (isModalOpen && capability === appNames.compass && countrySwitcherIndex === 1 && compassV2DropdownData && compassV2DropdownData.type === "SUCCESS_COMPASS_DROPDOWN_V2_ACTION") {
                const dropdownData = compassV2DropdownData?.data;               
                setDropdownValues(dropdownData)
                assignCompassDropdownValues(1, dropdownData);
        }
    }, [compassV2DropdownData, isModalOpen, capability, countrySwitcherIndex]);
    
    useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_ARCHLET_DROPDOWN_ACTION', 
                payload: "RESET_ARCHLET_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'RESET_ARIBA_DROPDOWN_ACTION', 
                payload: "RESET_ARIBA_DROPDOWN_ACTION" 
            });
            dispatch({ 
                type: 'RESET_MYRIS_DROPDOWN_ACTION', 
                payload: "RESET_MYRIS_DROPDOWN_ACTION" 
            });
        };
    }, []);      
    
    useEffect(() => {
        if (userData) {
            if (capability === appNames.marketIntel && appName === "SmartCube") {
                const formattedData = formatUserDataForVendorListApi(userData.details)
                dispatch(FetchSmartCubeCategoryAction(formattedData))// smart cube categories api call
            } 
            
            else if(capability===appNames.archlet) {
                const formattedData = formatUserDataForVendorListApi(userData.details)
                if(appName==="Archlet") {
                    const data = {
                        dropdownFilterRequestDetails: formattedData,
                        selectedBus: landingPageFilters?.bus?.map(item => (item.displayText))
                    }
                    dispatch(FetchArchletDropdownAction(data))
                    return;

                } else if(appName==="SAP Ariba") {
                    const data = {
                        dropdownFilterRequest: formattedData,
                    }
                    dispatch(FetchAribaDropdownAction(data))
                    return;
                }
            }
            else if(capability===appNames.r2pInsights) {
                const formattedData = formatUserDataForVendorListApi(userData.details)
                const data = {
                    dropdownFilterRequest: formattedData,
                }
                dispatch(FetchMyRISDropdownAction(data))
                return;
            }
            else if(capability===appNames.compass) {
                if (!isModalOpen) return;
                const formattedData = formatUserDataForVendorListApi(userData.details)
 
                const formattedDataWithCountry = formatUserDataForVendorListApiwithCountry(userData.details, userDataV2)
                
                const data = {
                    dropdownFilterRequest: formattedData,
                }
                const dataWithCountry = {
                    dropdownFilterRequest: formattedDataWithCountry,
                }
                if(countrySwitcherIndex === 0) dispatch(FetchCompassDropdownAction(data));
                if(countrySwitcherIndex === 1) dispatch(FetchCompassDropdownV2Action(dataWithCountry));
                // dispatch(FetchCompassDropdownAction(data))
                // dispatch(FetchCompassDropdownV2Action(dataWithCountry))
                // CALL THE EXTRACTED FUNCTION HERE
                // let capabilitySearchKey = getCapabilitySearchKey(appName,capability);
                //
                // const { tempFromDate, tempToDate } = updateDateSelections({
                //     dropdownData: userData, capabilitySearchKey,
                //     yearSelected: localStorage.getItem("yearSelected")
                // });
                return;
            }

            const Roles = getRoles(userData.details);
            const defaultRole = Roles.filter((item) => item.displayText === userData.defaultRole);
            setAllRoles(Roles)

            const getUserInfoByRole = userData?.details?.filter(item => item.role === landingPageFilters?.role[0]?.displayText)?.[0]
            setUserInfoByRole(getUserInfoByRole)

            let sectorsToInclude = landingPageFilters?.sectors?.map(item => (item.displayText ? item.displayText : item))
            const sectors = getSectors(getUserInfoByRole?.roleDetail);
            setSectors(sectors)
            const accessibleSectorsTemp = sectors?.map(item => (item.displayText))
            setUserAccessibleSectorList(accessibleSectorsTemp)

            let businessUnitsToInclude = landingPageFilters?.bus?.map(item => (item.displayText))
            const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
            setBusinessUnits(BUs)

            let categoriesToInclude = landingPageFilters?.l0s?.map(item => (item.displayText))
            let tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "")
            
            const l0dropdown = allCategoryL0 ? formatIntoDropdownData(categoriesToInclude, allCategoryL0) : []
           
            const result = l0dropdown.filter(item =>
                // landingPageFilters?.l0sSelected.some(selected => selected.id === item.id)
                landingPageFilters?.l0sSelected.some(selected => selected.displayText === item.displayText)
            );
            setCategoriesLevel0(l0dropdown)
            setCategoryL0Selected(result)
            ////
            localStorage.setItem('CategoryL0Selected', JSON.stringify(result))
            let categoriesL1ToInclude = landingPageFilters?.l1sSelected?.map(item => (item.displayText))
            const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "")
            setCategoriesLevel1(landingPageFilters?.l1s)

            const tempCategoriesLevel2 = getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
            let capabilitySearchKey = getCapabilitySearchKey(appName,capability);
            if (capability !== appNames.marketIntel || appName === "In-house MI Team") {
                setCategoriesLevel2(tempCategoriesLevel2);
                // setCategoryL2Selected(tempCategoriesLevel2);
                // localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesLevel2))
            }

            const minYear = atob(localStorage.getItem("minYear"));
            const maxYear = atob(localStorage.getItem("maxYear"));

            // setEntireMonthList(getMonthsWithYearRange(minYear, maxYear));/*OLD LOGIC*/
            setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

            // CALL THE EXTRACTED FUNCTION HERE
            const { tempFromDate, tempToDate } = updateDateSelections({
                dropdownData: userData, capabilitySearchKey,
                yearSelected: localStorage.getItem("yearSelected")
            });
            const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);
            const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
            /* const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

            let years = userData?.year?.slice();// [...userData.year]
            let compassMonthLists = generateMonthsList(years, maxDateObject)
            setCompassMonthList(compassMonthLists)

            
            const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
            setFromDates(fromDate);

            const yearSelected = localStorage.getItem("yearSelected");

            const date2 = new Date();
            const date2Year = date2.getFullYear();
            // console.log(fromDate);

            const fromDateMonth = capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`) ?
             'Dec' : 
             capability === appNames.compass? // && date2Year === Number(yearSelected) ? 
                maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'
            
            const tempFromDate = fromDate.filter((item) => {
                return item.displayText === (fromDateMonth + ' ' + yearSelected);
            })

            let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]); // Extracting year from maxDate
            let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
            let tempToDate = fromDate.filter((item) => {
                let temp = fromDate[fromDate.length - 1]?.displayText;

                let currentLastMonth = Number(yearSelected) < objectYear
                    ? "Dec " + yearSelected
                    : maxYearMonth;

                return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
            });

            const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
            setToDates(toDateOptions);
            */
            if (capability === appNames.powersteering) {
                setFromDateSelected(landingPageFilters.year)
                localStorage.setItem('fromDateSelected', JSON.stringify(landingPageFilters.year))
            } else {
                setFromDateSelected(tempFromDate);
                
                localStorage.setItem('fromDateSelected', JSON.stringify(tempFromDate))
            }
            dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: tempFromDate?.[0]?.['displayText'] }));
            setToDateSelected(tempToDate); 
            localStorage.setItem('toDateSelected', JSON.stringify(tempToDate))
            const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
            if (index !== -1) {
                const tempFromDates = fromDate.slice(0, index + 1);
                setFromDates(tempFromDates);
            }
            if(capability === appNames.powersteering){
                spendCardApiCallonChange(landingPageFilters?.role, landingPageFilters.sectors, landingPageFilters.bus, result, landingPageFilters.l1sSelected, tempCategoriesLevel2, landingPageFilters.year, tempToDate, accessibleSectorsTemp, 1)
            
            }
            else if ((capability !== appNames.marketIntel || appName === "In-house MI Team") && capability!==appNames.archlet) {
            // else if ((capability !== appNames.marketIntel || appName === "In-house MI Team")) {
                spendCardApiCallonChange(landingPageFilters?.role, landingPageFilters.sectors, landingPageFilters.bus, result, landingPageFilters.l1sSelected, tempCategoriesLevel2, tempFromDate, tempToDate, accessibleSectorsTemp, 1)
            }
        }
    }, [userData, countrySwitcherIndex, isModalOpen]);
    
    
    const showWarningMessage = (message) => {
        showToast('warning', message, {
            icon: <Icon alt="" icon="warning_amber" size="medium" />
        });

    }
    
    const spendCardApiCallonChange = (currentRole, sectors, BUs, categoryL0, categoryL1, categoryL2, fromDate, toDate, accessibleSectorList, key) => {
        // console.log(sectors, BUs, categoryL0, categoryL1, categoryL2, fromDate, toDate, accessibleSectorList);
        // console.log(fromDate, key);
        let sectorSelectedData = localStorage.getItem('sectorSelected')
        // if(sectorSelectedData){
            sectorSelectedData = JSON.parse(sectorSelectedData)
        // }
        //
        let currentRoleData = JSON.parse(localStorage.getItem('roleSelected'))
        let businessUnitSelectedData = JSON.parse(localStorage.getItem('BUSeleceted'))
        let countriesSelectedData = JSON.parse(localStorage.getItem('countriesSelected'))
        let categoryL0SelectedData = JSON.parse(localStorage.getItem('CategoryL0Selected'))
        let categoryL1SelectedData = JSON.parse(localStorage.getItem('categoryL1Selected'))
        let categoryL2SelectedData = JSON.parse(localStorage.getItem('categoryL2Selected'))
        let fromDateSelectedData = JSON.parse(localStorage.getItem('fromDateSelected'))
        let toDateSelectedData = JSON.parse(localStorage.getItem('toDateSelected'))

        // console.log("toDateSelectedData", toDateSelectedData)
        ////
        const l0Category = capability === appNames.coman ? coManL0Category : categoryL0
        // const spendRequest = {
        //     fromDate: fromDate?.[0]?.value || '',
        //     toDate: toDate?.[0]?.value || '',
        //     // sector: sectors?.map((item) => item.displayText ? item.displayText : item),
        //     sector: sectorSelectedData?.map((item) => item.displayText ? item.displayText : item),
        //     bu: BUs?.map((item) => item.displayText),
        //     l0: l0Category?.map((item) => item.displayText),
        //     l1: categoryL1?.map((item) => item.displayText),
        //     l2: categoryL2?.map((item) => item.displayText),
        //     accessibleUserSectors: accessibleSectorList // userAccessibleSectors
        // };

        const spendRequest = {
            fromDate: fromDateSelectedData?.[0]?.value || '',
            toDate: toDateSelectedData?.[0]?.value || '',
            // sector: sectors?.map((item) => item.displayText ? item.displayText : item),
            sector: sectorSelectedData?.map((item) => item.displayText ? item.displayText : item),
            bu: businessUnitSelectedData?.map((item) => item.displayText),
            l0: categoryL0SelectedData?.map((item) => item.displayText),
            l1: categoryL1SelectedData?.map((item) => item.displayText),
            l2: categoryL2SelectedData?.map((item) => item.displayText),
            accessibleUserSectors: accessibleSectorList // userAccessibleSectors
        };

        // console.log("categoryL1SelectedData", categoryL1SelectedData)
        // console.log("categoryL2SelectedData", categoryL2SelectedData)
        // console.log("capability", capability)
        // console.log("categoryL2", categoryL2)

        /* Detail API calls for API integrated Filters */
        if (capability === appNames.archlet || capability === appNames.r2pInsights || capability === appNames.compass) {
            if(fromDate && toDate) {
                
                if(!(sectorSelectedData.length > 0 
                    && businessUnitSelectedData.length > 0 
                    && categoryL0SelectedData.length > 0 
                    && categoryL1SelectedData.length > 0 
                    && categoryL2SelectedData.length > 0)) {
                        message.warning("Please select required filters");
                }
                if(capability === appNames.archlet) {
                    if(appName==="Archlet") {
                        dispatch(FetchArchletDetailAction(spendRequest));
                    } else {
                        dispatch(FetchAribaKpiAction(spendRequest));
                    }
                } else if(capability === appNames.r2pInsights) {
                    dispatch(FetchMyRISDetailAction(spendRequest));
                // } else if (capability === appNames.compass && categoryL1SelectedData.length > 0 && categoryL2SelectedData.length > 0) {
                } else if (capability === appNames.compass) {
                    
                    const compassReqObj = {
                        yearMonth: fromDateSelectedData?.[0]?.displayText || 'Jan 2025',
                        bu: businessUnitSelectedData?.map((item) => item.displayText),
                        ...(countrySwitcherIndex === 1
                            ? { country: countriesSelectedData?.map((item) => item.displayText) }
                            : {}),
                        sector: sectorSelectedData?.map((item) => item.displayText ? item.displayText : item),
                        l0: categoryL0SelectedData?.map((item) => item.displayText),
                        l1: categoryL1SelectedData?.map((item) => item.displayText),
                        l2: categoryL2SelectedData?.map((item) => item.displayText),
                        isModalOld: countrySwitcherIndex === 0 ? true : false
                    };               
                    // dispatch(FetchCompassDetailAction(compassReqObj));
                    const isNullOrEmpty = (value) => {
                        if (value === null || value === undefined) return true;
                        if (Array.isArray(value)) return value.length === 0;
                        if (typeof value === 'string') return value.trim().length === 0;
                        return false;
                    };

                    const requiredValues = [
                        compassReqObj.yearMonth,
                        compassReqObj.sector,
                        compassReqObj.bu,
                        compassReqObj.l0,
                        compassReqObj.l1,
                        compassReqObj.l2,
                        ...(countrySwitcherIndex === 1 ? [compassReqObj.country] : []),
                    ];

                    const hasAnyMissingRequiredValue = requiredValues.some(isNullOrEmpty);

                    if (hasAnyMissingRequiredValue) {
                        dispatch(FetchCompasskpiPageHeaderAction(compassReqObj));

                        let compassReqObjSecondary = {
                            yearMonth: fromDateSelectedData?.[0]?.displayText || 'Jan 2025',
                            bu: [''],
                            // ...(countrySwitcherIndex === 1
                            //     ? { country: [''] }
                            //     : {}),
                            sector: [''],
                            l0: [''],
                            l1: [''],
                            l2: [''],
                            isModalOld: countrySwitcherIndex === 0 ? true : false
                        }

                        dispatch(FetchCompassCoverageReportChartAction(compassReqObjSecondary));
                        dispatch(FetchCompassExecutiveSummaryAction(compassReqObjSecondary));
                        dispatch(FetchCompassSectorBuChartAction(compassReqObjSecondary));
                        dispatch(FetchCompassSectorCategoryChartAction(compassReqObjSecondary));
                        
                    } else {
                        dispatch(FetchCompasskpiPageHeaderAction(compassReqObj));
                        dispatch(FetchCompassCoverageReportChartAction(compassReqObj));
                        dispatch(FetchCompassExecutiveSummaryAction(compassReqObj));
                        dispatch(FetchCompassSectorBuChartAction(compassReqObj));
                        dispatch(FetchCompassSectorCategoryChartAction(compassReqObj));
                    }
                    
                }

            } else {
                message.warning("Please select required filters");
                onParentCallback({ data: {}, loader: false, monthDiff })
            }
            
            setApiLoader(false);
        }
        

        /* Detail API calls for NON-API integrated Filters */
        if (sectorSelectedData.length > 0 && businessUnitSelectedData.length > 0 && categoryL0SelectedData.length > 0) {
            if (capability === appNames.spend && fromDate && toDate) {
                if (currentController) {
                    currentController.abort(); // cancel the old one
                }
            
                currentController = new AbortController();
                const signal = currentController.signal;

                dispatch(FetchSpendDetailAction(spendRequest, signal));
            } else if (capability === appNames.coman && fromDate && toDate) {
                dispatch(FetchSupplierPerfDetail(spendRequest));
            } else if (capability === appNames.contract && fromDate && toDate) {
                dispatch(FetchContractDetailAction(spendRequest));
            } else if (capability === appNames.marketIntel && appName == "SmartCube") {
                dispatch(FetchMarketIntelDetailAction(spendRequest));
            } else if (capability === appNames.marketIntel && appName == "In-house MI Team") {
                // dispatch(FetchMarketIntelDetailAction(spendRequest));
                dispatch(FetchMarketIntelInHouseDetailAction(spendRequest));
            } else if (capability === appNames.shouldCostModelling && categoryL1SelectedData.length > 0 && categoryL2SelectedData.length > 0 && fromDate && toDate) {
            
                dispatch(FetchSCMKpiAction(spendRequest));
            } 
            // else if (capability === appNames.compass && categoryL1SelectedData.length > 0 && categoryL2SelectedData.length > 0) {
            //     // let compassYear = Number(fromDate?.[0]?.displayText?.split(' ')?.[1])
            //     // const compassReqObj = {
            //     //     yearMonth: fromDate?.[0]?.displayText || 'Jan 2024',
            //     //     bu: BUs?.map((item) => item.displayText),
            //     //     sector: sectors?.map((item) => item.displayText ? item.displayText : item),
            //     //     l0: l0Category?.map((item) => item.displayText),
            //     //     l1: categoryL1?.map((item) => item.displayText),
            //     //     l2: categoryL2?.map((item) => item.displayText),
            //     // };
            //     // console.log("categoryL1", "categoryL2")
                
            //     const compassReqObj = {
            //         yearMonth: fromDateSelectedData?.[0]?.displayText || 'Jan 2025',
            //         bu: businessUnitSelectedData?.map((item) => item.displayText),
            //         ...(countrySwitcherIndex === 1
            //             ? { country: countriesSelectedData?.map((item) => item.displayText) }
            //             : {}),
            //         sector: sectorSelectedData?.map((item) => item.displayText ? item.displayText : item),
            //         l0: categoryL0SelectedData?.map((item) => item.displayText),
            //         l1: categoryL1SelectedData?.map((item) => item.displayText),
            //         l2: categoryL2SelectedData?.map((item) => item.displayText),
            //         isModalOld: countrySwitcherIndex === 0 ? true : false
            //     };               
                // dispatch(FetchCompassDetailAction(compassReqObj));
            //     dispatch(FetchCompassCoverageReportChartAction(compassReqObj));
            //     dispatch(FetchCompassExecutiveSummaryAction(compassReqObj));
            //     dispatch(FetchCompassSectorBuChartAction(compassReqObj));
            //     dispatch(FetchCompassSectorCategoryChartAction(compassReqObj));
            //     dispatch(FetchCompasskpiPageHeaderAction(compassReqObj));
            // } 
            else if (capability === appNames.powersteering && categoryL1SelectedData.length > 0 && categoryL2SelectedData.length > 0) {
                // let year = Number(fromDate?.[0]?.displayText?.split(' ')?.[1])
                // const powerSteeringReqObj = {
                //     year: fromDate?.[0]?.displayText || 2024,
                //     bu: BUs?.map((item) => item.displayText),
                //     sector: sectors?.map((item) => item.displayText ? item.displayText : item),
                //     l0: l0Category?.map((item) => item.displayText),
                //     l1: categoryL1?.map((item) => item.displayText),
                //     accessibleUserSectors: accessibleSectorList
                //     // l2: categoryL2?.map((item) => item.displayText),
                // };
                
                const powerSteeringReqObj = {
                    year: fromDateSelectedData?.[0]?.displayText || 2025,
                    bu: businessUnitSelectedData?.map((item) => item.displayText),
                    sector: sectorSelectedData?.map((item) => item.displayText ? item.displayText : item),
                    l0: categoryL0SelectedData?.map((item) => item.displayText),
                    l1: categoryL1SelectedData?.map((item) => item.displayText),
                    accessibleUserSectors: accessibleSectorList
                    // l2: categoryL2?.map((item) => item.displayText),
                };
                getSelectedYear(powerSteeringReqObj)
                dispatch(FetchPowerSteeringKpiAction(powerSteeringReqObj));
            } else if (capability === appNames.forestreet && categoryL1SelectedData.length > 0 && categoryL2SelectedData.length > 0) {
                // let year = Number(fromDate?.[0]?.displayText?.split(' ')?.[1])
                const foreStreetReqObj = {
                    fromDate: fromDateSelectedData?.[0]?.value || '',
                    toDate: toDateSelectedData?.[0]?.value || '',
                    bu: businessUnitSelectedData?.map((item) => item.displayText),
                    sector: sectorSelectedData?.map((item) => item.displayText ? item.displayText : item),
                    l0: categoryL0SelectedData?.map((item) => item.displayText),
                    l1: categoryL1SelectedData?.map((item) => item.displayText),
                    accessibleUserSectors: accessibleSectorList,
                    email: userData?.emailId,
                    //email: "amit.agarwala.contractor@pepsico.com",
                    role: currentRoleData.length>0 ? currentRoleData[0]['displayText'] : userData.defaultRole
                    // l2: categoryL2?.map((item) => item.displayText),
                };
                // getSelectedYear(foreStreetReqObj)
                if(appName=="Veridion (V)") {
                    const veridionReqObj = {
                        ...foreStreetReqObj,
                        l2:categoryL2SelectedData?.map((item) => item.displayText)
                    }
                    dispatch(FetchVeridionKpiAction(veridionReqObj));
                } else if(appName=="Forestreet (F)") {
                    dispatch(FetchForeStreetKpiAction(foreStreetReqObj));

                }
            }
            setApiLoader(false);
        } else {
            if(![appNames.archlet, appNames.r2pInsights].includes(capability)) {
                message.warning("Please select required filters");
                setApiLoader(false);
                onParentCallback({ data: {}, loader: false, monthDiff })
            }
        }
    };
    
    const getCapabilitySearchKey = (appName,capability) => {
        return (appName === "In-house MI Team") || (capability===appNames.forestreet) || (capability===appNames.archlet) ? appName : capability;  
    }
    
    const assignDropdownValues = (dropdownData) => {
        const Roles = getRoles(dropdownData.details); // dropdownData.detailDTOList
        const defaultRole = Roles.filter((item) => item.displayText === dropdownData.defaultRole);
        setAllRoles(Roles)
        const getUserInfoByRole = dropdownData?.details?.filter(item => item.role === landingPageFilters?.role[0]?.displayText)?.[0] // dropdownData.detailDTOList
        setUserInfoByRole(getUserInfoByRole)

        /* Sector Dropdown Setup */
        let sectorsToInclude = landingPageFilters?.sectors?.map(item => (item.displayText ? item.displayText : item))
        const sectors = getSectors(getUserInfoByRole?.roleDetail);
        
        setSectors(sectors)
        const accessibleSectorsTemp = sectors?.map(item => (item.displayText))
        setUserAccessibleSectorList(accessibleSectorsTemp)

        const sectorsToSelect= (getOverlappingOptions(getSectors(getUserInfoByRole?.roleDetail),landingPageFilters?.sectors))
        setSectorSelected(sectorsToSelect)
        localStorage.setItem("sectorSelected", JSON.stringify(sectorsToSelect))
        dispatch(setKeyValue({ key: localStoreKeys.sectorSelectedOnDetail, value: sectorsToSelect }))


        /* BU Dropdown Setup */
        let businessUnitsToInclude = landingPageFilters?.bus?.map(item => (item.displayText))
        const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
        setBusinessUnits(BUs)

        const busToSelect= (getOverlappingOptions(BUs,landingPageFilters?.bus, capability, "bu",dropdownData?.bus))
        setBusinessUnitSelected(busToSelect)
        localStorage.setItem('BUSeleceted', JSON.stringify(busToSelect))



        /* L0 Categories Dropdown Setup */
        let categoriesToInclude = landingPageFilters?.l0s?.map(item => (item.displayText))
        let tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "")
        const l0dropdown = allCategoryL0 ? formatIntoDropdownData(categoriesToInclude, tempCategories) : []
        const result = l0dropdown.filter(item =>
            landingPageFilters?.l0sSelected.some(selected => selected.displayText === item.displayText)
        );
        setCategoriesLevel0(tempCategories)

        setCategoryL0Selected(result)
        localStorage.setItem('CategoryL0Selected', JSON.stringify(result))

        
        /* L1 Categories Dropdown Setup */
        let categoriesL1ToInclude = landingPageFilters?.l1sSelected?.map(item => (item.displayText))
        const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, result?.map(item => (item.displayText)), sectorsToInclude, businessUnitsToInclude, "")
        setCategoriesLevel1(tempCategoriesLevel1)

        const l1sToSelect = (getOverlappingOptions(tempCategoriesLevel1,landingPageFilters?.l1sSelected))
        setCategoryL1Selected(l1sToSelect)
        localStorage.setItem('categoryL1Selected', JSON.stringify(l1sToSelect))


        /* L2 Categories Dropdown Setup */
        const tempCategoriesLevel2 = getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
        let capabilitySearchKey = getCapabilitySearchKey(appName,capability);
        if (capability !== appNames.marketIntel || appName === "In-house MI Team") {
            setCategoriesLevel2(tempCategoriesLevel2);
            // setCategoryL2Selected(tempCategoriesLevel2);
            // localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesLevel2))
            
            const l2sToSelect = (getOverlappingOptions(tempCategoriesLevel2,landingPageFilters?.l2sSelected))
            setCategoryL2Selected(l2sToSelect)
            localStorage.setItem('categoryL2Selected', JSON.stringify(l2sToSelect))
        }
        
        setRoleSelected(landingPageFilters?.role)
        localStorage.setItem("roleSelected", JSON.stringify(landingPageFilters?.role))

        setMonthYearDate(landingPageFilters?.year)

        const minYear = atob(localStorage.getItem("minYear"));
        const maxYear = atob(localStorage.getItem("maxYear"));

        setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

        const { tempFromDate, tempToDate } = updateDateSelections({
            dropdownData,
            capabilitySearchKey,
            yearSelected: localStorage.getItem("yearSelected")
        });
        /*const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

        let years = dropdownData?.year?.slice();
        // FROM LINE THIS
        let compassMonthLists = generateMonthsList(years, maxDateObject)
        setCompassMonthList(compassMonthLists)
        
        const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
        setFromDates(fromDate);

        const yearSelected = localStorage.getItem("yearSelected");

        const date2 = new Date();
        const date2Year = date2.getFullYear();
        // console.log(fromDate);

        // const fromDateMonth = capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`) ? 'Dec' : capability === appNames.compass && date2Year === Number(yearSelected) ? maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'
        const fromDateMonth = capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`) ?
             'Dec' : 
             capability === appNames.compass? // && date2Year === Number(yearSelected) ? 
                maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'

        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })
        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]); // Extracting year from maxDate
        let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setToDates(toDateOptions);

        if (capability === appNames.powersteering) {
            setFromDateSelected(landingPageFilters.year)
            localStorage.setItem('fromDateSelected', JSON.stringify(landingPageFilters.year))
        } else {
            setFromDateSelected(tempFromDate);
            
            localStorage.setItem('fromDateSelected', JSON.stringify(tempFromDate))
        }
        dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: tempFromDate?.[0]?.['displayText'] }));
        setToDateSelected(tempToDate); 
        localStorage.setItem('toDateSelected', JSON.stringify(tempToDate))
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }
        // TO LINE THIS
        */
        spendCardApiCallonChange(
            landingPageFilters?.role,
            landingPageFilters.sectors,
            landingPageFilters.bus,
            result,
            landingPageFilters.l1sSelected,
            tempCategoriesLevel2,
            tempFromDate,
            tempToDate,
            accessibleSectorsTemp,
            1
        )
               
    }

    
    const assignV2DropdownValues = (dropdownData) => {
        
        const Roles = getRoles(dropdownData.details); // dropdownData.detailDTOList
        // const defaultRole = Roles.filter((item) => item.displayText === dropdownData.defaultRole);
        const defaultRole = userDataV2?.defaultRole;
        setAllRoles(Roles)
        
        setRoleSelected(defaultRole);
        localStorage.setItem("roleSelected", JSON.stringify(defaultRole))
        // const getUserInfoByRole = dropdownData?.details?.filter(item => item.role === landingPageFilters?.role[0]?.displayText)?.[0] // dropdownData.detailDTOList
        const getUserInfoByRole = dropdownData?.details?.filter(item => item.role === defaultRole)?.[0] // dropdownData.detailDTOList
        setUserInfoByRole(getUserInfoByRole)

        /* Sector Dropdown Setup */
        let sectorsToInclude = landingPageFilters?.sectors?.map(item => (item.displayText ? item.displayText : item))
        if(countrySwitcherIndex === 1){
            sectorsToInclude = getSectorsV2(getUserInfoByRole?.sector)?.map(item => (item.displayText ? item.displayText : item))
        }
        const sectors = getSectorsV2(getUserInfoByRole?.sector);
        setSectors(sectors)
        const accessibleSectorsTemp = sectors?.map(item => (item.displayText))
        setUserAccessibleSectorList(accessibleSectorsTemp)

        let sectorsToSelect= (getOverlappingOptions(getSectorsV2(getUserInfoByRole?.sector),landingPageFilters?.sectors))

        if(countrySwitcherIndex === 1){
             sectorsToSelect = getSectorsV2(getUserInfoByRole?.sector)
        }
        
        setSectorSelected(sectorsToSelect)
        localStorage.setItem("sectorSelected", JSON.stringify(sectorsToSelect))
        dispatch(setKeyValue({ key: localStoreKeys.sectorSelectedOnDetail, value: sectorsToSelect }))


        /* BU Dropdown Setup */
        let businessUnitsToInclude = landingPageFilters?.bus?.map(item => (item.displayText))
        if(countrySwitcherIndex === 1){
            businessUnitsToInclude = getBusinessUnitsBySectorV2(getUserInfoByRole?.sector, sectorsToInclude)?.map(item => (item.displayText))
        }
        const BUs = getBusinessUnitsBySectorV2(getUserInfoByRole?.sector, sectorsToInclude);
        setBusinessUnits(BUs)

        let busToSelect= (getOverlappingOptions(BUs,landingPageFilters?.bus, capability, "bu",dropdownData?.bus))
        if(countrySwitcherIndex === 1){
            busToSelect = getBusinessUnitsBySectorV2(getUserInfoByRole?.sector, sectorsToInclude)
        }
        setBusinessUnitSelected(busToSelect)
        localStorage.setItem('BUSeleceted', JSON.stringify(busToSelect))

        /* Country Dropdown Setup */
        // let businessUnitsToInclude = landingPageFilters?.bus?.map(item => (item.displayText))
        const Countries = getCountriesBySectorBuV2(getUserInfoByRole?.sector, sectorsToInclude, businessUnitsToInclude);
        
        setCountries(Countries)


        //Not using this since we don't have country filter in overview page .
        // const countriesToSelect= (getOverlappingOptions(BUs,landingPageFilters?.bus, capability, "bu",dropdownData?.bus))
        // setCountriesSelected(countriesToSelect)
        // localStorage.setItem('countriesSelected', JSON.stringify(countriesToSelect))

        setCountriesSelected(Countries)
        localStorage.setItem('countriesSelected', JSON.stringify(Countries))

        /* L0 Categories Dropdown Setup */
        let categoriesToInclude = (landingPageFilters?.l0s || []).map((item) => item.displayText)
        if(countrySwitcherIndex === 1){
            categoriesToInclude = getCategoryL0ListV2(getUserInfoByRole?.category)?.map((item) => item.displayText)
        }
        const tempCategories = getCategoryL0ListV2(getUserInfoByRole?.category)
        const selectedL0DisplayText = new Set((landingPageFilters?.l0sSelected || []).map((selected) => selected.displayText));
        const l0dropdown = allCategoryL0 ? formatIntoDropdownData(categoriesToInclude, tempCategories) : []
        let result = l0dropdown.filter(({ displayText }) => selectedL0DisplayText.has(displayText));
        if(countrySwitcherIndex === 1){
            result = getCategoryL0ListV2(getUserInfoByRole?.category)
        }     
        
        setCategoriesLevel0(tempCategories)

        setCategoryL0Selected(result)
        localStorage.setItem('CategoryL0Selected', JSON.stringify(result))

        
        /* L1 Categories Dropdown Setup */
        let categoriesL1ToInclude = (landingPageFilters?.l1sSelected || []).map((item) => item.displayText)
        
        const tempCategoriesLevel1 = getCategoryL1ListV2(getUserInfoByRole?.category, categoriesToInclude)
        if(countrySwitcherIndex === 1) {
            categoriesL1ToInclude = tempCategoriesLevel1?.map((item) => item.displayText) // Resetting Logic by default: 16 June change to pass categories L1 in sector bu country
        }
        setCategoriesLevel1(tempCategoriesLevel1)

        let l1sToSelect = getOverlappingOptions(tempCategoriesLevel1, landingPageFilters?.l1sSelected || [])
        if(countrySwitcherIndex === 1){
            l1sToSelect = getCategoryL1ListV2(getUserInfoByRole?.category, categoriesToInclude)
        }
        setCategoryL1Selected(l1sToSelect)
        localStorage.setItem('categoryL1Selected', JSON.stringify(l1sToSelect))


        /* L2 Categories Dropdown Setup */
        const tempCategoriesLevel2 = getCategoryL2ListV2(getUserInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
        const capabilitySearchKey = getCapabilitySearchKey(appName, capability);
        const shouldApplyL2 = capability !== appNames.marketIntel || appName === "In-house MI Team";
        if (shouldApplyL2) {
            setCategoriesLevel2(tempCategoriesLevel2);
            
            let l2sToSelect = getOverlappingOptions(tempCategoriesLevel2, landingPageFilters?.l2sSelected)
            if(countrySwitcherIndex === 1){
                l2sToSelect = getCategoryL2ListV2(getUserInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
                // l2sToSelect = getCategoryL2ListV2(getUserInfoByRole?.category, categoriesToInclude, tempCategoriesLevel1)
            }
            
            setCategoryL2Selected(l2sToSelect)
            localStorage.setItem('categoryL2Selected', JSON.stringify(l2sToSelect))
        }

        // Calculate role id by finding the position in userDataV2.details
        // const roleDisplayText = landingPageFilters?.role?.[0]?.displayText;
        const roleDisplayText = userDataV2?.defaultRole;
        const roleIdIndex = userDataV2?.details?.findIndex(item => item.role === roleDisplayText);
        
        // const roleWithCalculatedId = roleDisplayText ? [{
        //     displayText: roleDisplayText,
        //     id: roleIdIndex >= 0 ? roleIdIndex + 1 : landingPageFilters?.role?.[0]?.id
        // }] : landingPageFilters?.role;
        const roleWithCalculatedId = [{
            displayText: roleDisplayText,
            id: roleIdIndex >= 0 ? roleIdIndex + 1 : 0
        }] 
        
        setRoleSelected(roleWithCalculatedId);
        localStorage.setItem("roleSelected", JSON.stringify(roleWithCalculatedId))
        setMonthYearDate(landingPageFilters?.year)

        const yearKeys = ["minYear", "maxYear"];
        const decodedYears = yearKeys.map((key) => atob(localStorage.getItem(key)));
        setEntireMonthList(
            getMonthsWithYearRangeAdjustedForMaxDate(
                decodedYears[0],
                decodedYears[1],
                capabilitySearchKey,
                maxDateForApps
            )
        );

        const dateSelections = updateDateSelections({
            capabilitySearchKey,
            dropdownData,
            yearSelected: localStorage.getItem("yearSelected")
        });

        spendCardApiCallonChange(
            landingPageFilters?.role,
            landingPageFilters?.sectors,
            landingPageFilters?.bus,
            result,
            landingPageFilters?.l1sSelected,
            tempCategoriesLevel2,
            dateSelections?.tempFromDate,
            dateSelections?.tempToDate,
            accessibleSectorsTemp,
            1
        )
               
    }

    
    const assignCompassDropdownValues = (mode, dropdownData) => {
        
        const compassSnapshot = compassFilterSnapshot;
        const isCountryMode = mode === 1;
        const roles = getRoles(dropdownData.details);
        // const defaultRole = isCountryMode ? userDataV2?.defaultRole : dropdownData.defaultRole;
        const defaultRole = isCountryMode ? userDataV2?.defaultRole : dropdownData?.details?.filter(item => item.role === landingPageFilters?.role[0]?.displayText)?.[0]?.role;
        const selectedRole = selectSavedOptions(
            roles,
            compassSnapshot?.role,
            roles.filter(item => item.displayText === defaultRole)
        );
        const selectedRoleName = selectedRole?.[0]?.displayText || defaultRole;
        const userRole = dropdownData?.details?.find(item => item.role === selectedRoleName);

        setAllRoles(roles);
        setRoleSelected(selectedRole);
        setUserInfoByRole(userRole);
        localStorage.setItem("roleSelected", JSON.stringify(selectedRole));

        const roleSectors = isCountryMode ? userRole?.sector : userRole?.roleDetail;
        const sectorOptions = isCountryMode ? getSectorsV2(roleSectors) : getSectors(roleSectors);
        const selectedSectors = selectSavedOptions(
            sectorOptions,
            compassSnapshot?.sectors,
            isCountryMode ? sectorOptions : getOverlappingOptions(sectorOptions, landingPageFilters?.sectors)
        );
        const sectorNames = selectedSectors.map(item => item.displayText);
        const accessibleSectors = sectorOptions.map(item => item.displayText);

        setSectors(sectorOptions);
        setSectorSelected(selectedSectors);
        setUserAccessibleSectorList(accessibleSectors);
        localStorage.setItem("sectorSelected", JSON.stringify(selectedSectors));
        dispatch(setKeyValue({ key: localStoreKeys.sectorSelectedOnDetail, value: selectedSectors }));

        const businessUnitOptions = isCountryMode
            ? getBusinessUnitsBySectorV2(roleSectors, sectorNames)
            : getBusinessUnitsBySector(roleSectors, sectorNames);
        const selectedBusinessUnits = selectSavedOptions(
            businessUnitOptions,
            compassSnapshot?.businessUnits,
            isCountryMode
                ? businessUnitOptions
                : getOverlappingOptions(businessUnitOptions, landingPageFilters?.bus, capability, "bu", dropdownData?.bus)
        );
        const businessUnitNames = selectedBusinessUnits.map(item => item.displayText);

        setBusinessUnits(businessUnitOptions);
        setBusinessUnitSelected(selectedBusinessUnits);
        localStorage.setItem("BUSeleceted", JSON.stringify(selectedBusinessUnits));

        let l0Options;
        if (isCountryMode) {
            l0Options = getCategoryL0ListV2(userRole?.category);
        } else {
            l0Options = getCategoriesBySectorAndBusinessUnit(roleSectors, sectorNames, businessUnitNames, "");
        }
        const l0Defaults = getOverlappingOptions(l0Options, landingPageFilters?.l0sSelected);
        const selectedL0 = selectSavedOptions(l0Options, compassSnapshot?.categoryL0, l0Defaults);
        const l0Names = selectedL0.map(item => item.displayText);

        setCategoriesLevel0(l0Options);
        setCategoryL0Selected(selectedL0);
        localStorage.setItem("CategoryL0Selected", JSON.stringify(selectedL0));

        const l1Options = isCountryMode
            ? getCategoryL1ListV2(userRole?.category, l0Names)
            : getCategoriesLevel1(roleSectors, l0Names, sectorNames, businessUnitNames, "");
        const l1Defaults = getOverlappingOptions(l1Options, landingPageFilters?.l1sSelected);
        const selectedL1 = selectSavedOptions(l1Options, compassSnapshot?.categoryL1, l1Defaults);
        const l1Names = selectedL1.map(item => item.displayText);

        setCategoriesLevel1(l1Options);
        setCategoryL1Selected(selectedL1);
        localStorage.setItem("categoryL1Selected", JSON.stringify(selectedL1));

        const l2Options = isCountryMode
            ? getCategoryL2ListV2(userRole?.category, l0Names, l1Names)
            : getCategoriesLevel2(roleSectors, l0Names, l1Names, sectorNames, businessUnitNames, "");
        const shouldApplyL2 = capability !== appNames.marketIntel || appName === "In-house MI Team";
        const selectedL2 = shouldApplyL2
            ? selectSavedOptions(
                l2Options,
                compassSnapshot?.categoryL2,
                getOverlappingOptions(l2Options, landingPageFilters?.l2sSelected)
            )
            : [];

        if (shouldApplyL2) {
            setCategoriesLevel2(l2Options);
            setCategoryL2Selected(selectedL2);
            localStorage.setItem("categoryL2Selected", JSON.stringify(selectedL2));
        }

        const countryOptions = isCountryMode
            ? getCountriesBySectorBuV2(roleSectors, sectorNames, businessUnitNames)
            : [];
        const landingCountries = landingPageFilters?.countriesSelected || landingPageFilters?.countries;
        const selectedCountries = isCountryMode
            ? selectSavedOptions(
                countryOptions,
                compassSnapshot?.countries,
                landingCountries ? getOverlappingOptions(countryOptions, landingCountries) : countryOptions
            )
            : [];
        setCountries(countryOptions);
        setCountriesSelected(selectedCountries);
        localStorage.setItem("countriesSelected", JSON.stringify(selectedCountries));

        const capabilitySearchKey = getCapabilitySearchKey(appName, capability);
        setMonthYearDate(landingPageFilters?.year);
        if (isCountryMode) {
            const yearKeys = ["minYear", "maxYear"];
            const decodedYears = yearKeys.map(key => atob(localStorage.getItem(key)));
            setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(
                decodedYears[0], decodedYears[1], capabilitySearchKey, maxDateForApps
            ));
        } else {
            const minYear = atob(localStorage.getItem("minYear"));
            const maxYear = atob(localStorage.getItem("maxYear"));
            setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(
                minYear, maxYear, capabilitySearchKey, maxDateForApps
            ));
        }

        const dateSelections = updateDateSelections({
            dropdownData,
            capabilitySearchKey,
            yearSelected: localStorage.getItem("yearSelected"),
            savedFromDateSelected: compassSnapshot?.fromDateSelected
        });

        spendCardApiCallonChange(
            selectedRole,
            selectedSectors,
            selectedBusinessUnits,
            selectedL0,
            selectedL1,
            selectedL2,
            dateSelections?.compassFromDate,
            dateSelections?.tempToDate,
            accessibleSectors,
            1
        );
        compassFilterSnapshotReady.current = true;
    };

    const updateDateSelections = (params) => {
        const {
            dropdownData,
            capabilitySearchKey,
            // maxDateForApps,
            // selectedYear,
            yearSelected,
            savedFromDateSelected,
            /*capability,
            appNames,
            landingPageFilters,
            localStoreKeys,
            dispatch,
            setCompassMonthList,
            setFromDates,
            setFromDateSelected,
            setToDates,
            setToDateSelected*/
        } = params;
    
        const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);
        let years = dropdownData?.year?.slice();
        let compassYears = userData?.year?.slice();
        
        // Generate and set compass month list
        let compassMonthLists = generateMonthsList(compassYears, maxDateObject);
        setCompassMonthList(compassMonthLists);
    
        // Get and set fromDate options
        const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
        setFromDates(fromDate);
    
        // Logic for finding the specific From Date Month
        const fromDateMonth = (capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`)) 
            ? 'Dec' 
            : (capability === appNames.compass) 
                ? maxDateObject?.maxYearMonth?.split(" ")?.[0] 
                : 'Jan';
    
        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        });
        const savedCompassMonth = capability === appNames.compass
            ? compassMonthLists?.find(item => item.displayText === savedFromDateSelected?.[0]?.displayText)
            : undefined;
        const compassFromDate = capability === appNames.compass
            ? (savedCompassMonth ? [savedCompassMonth] : tempFromDate)
            : undefined;
    
        // Logic for finding the specific To Date Month
        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);
        let maxYearMonth = maxDateObject?.maxYearMonth;
        
        let tempToDate = fromDate.filter((item) => {
            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;
    
            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });
    
        // Handle toDate options based on fromDate selection
        const toDateOptions = getToDateOptionsWithMaxDate(
            (capability === appNames.compass ? compassFromDate : tempFromDate)?.[0]?.['displayText'],
            maxDateObject
        );
        setToDates(toDateOptions);
    
        // Set selections and LocalStorage
        if (capability === appNames.powersteering) {
            setFromDateSelected(landingPageFilters.year);
            localStorage.setItem('fromDateSelected', JSON.stringify(landingPageFilters.year));
        } else if (capability === appNames.compass) {
            setFromDateSelected(compassFromDate);
            localStorage.setItem('fromDateSelected', JSON.stringify(compassFromDate));
        } else {
            setFromDateSelected(tempFromDate);
            localStorage.setItem('fromDateSelected', JSON.stringify(tempFromDate));
        }
    
        dispatch(setKeyValue({
            key: localStoreKeys.fromDateDisplayValue,
            value: (capability === appNames.compass ? compassFromDate : tempFromDate)?.[0]?.['displayText']
        }));
        
        setToDateSelected(tempToDate);
        localStorage.setItem('toDateSelected', JSON.stringify(tempToDate));
    
        // Narrow down fromDates based on toDate index
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }
    
        return { tempFromDate, tempToDate, compassFromDate }; // Return these for use in API calls
    };

    
    const onRoleChange = (val) => {
        
        if (val && val.length>0) {
            setLoader(true)
            setRoleSelected(val);
            localStorage.setItem("roleSelected", JSON.stringify(val))
            let getUserInfoByRole = userData?.details?.filter(item => item.role === val[0]?.displayText)?.[0];
            // let getUserInfoByRole = countrySwitcherIndex == 0 ? userData?.details?.filter(item => item.role === val[0]?.displayText)?.[0] : userDataV2?.details?.filter(item => item.role === val[0]?.displayText)?.[0];
            // let getUserInfoByRole = countrySwitcherIndex == 0 ? userData?.details?.filter(item => item.role === val[0]?.displayText)?.[0] : dropdownValues?.details?.filter(item => item.role === val[0]?.displayText)?.[0];
            if(capability===appNames.archlet || capability===appNames.r2pInsights || capability===appNames.compass) {
                getUserInfoByRole = dropdownValues?.details?.filter(item => item.role === val[0]?.displayText)?.[0];
            }
            setUserInfoByRole(getUserInfoByRole)
            const sectors = countrySwitcherIndex == 0 ? getSectors(getUserInfoByRole?.roleDetail) : getSectorsV2(getUserInfoByRole?.sector);
            setSectors(sectors)
            setSectorSelected(sectors)
            localStorage.setItem("sectorSelected", JSON.stringify(sectors))
            let sectorsToInclude = sectors?.map(item => (item.displayText ? item.displayText : item))
            setUserAccessibleSectorList(sectorsToInclude)
            const BUs = countrySwitcherIndex == 0 ? getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude) : getBusinessUnitsBySectorV2(getUserInfoByRole?.sector, sectorsToInclude);
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            localStorage.setItem('BUSeleceted', JSON.stringify(BUs))
            if (capability === appNames.marketIntel && appName == "SmartCube") {
                const defaultRole = val[0]['displayText']
                const roleDetails = smartcubeCategories?.data?.filter(item => defaultRole === item.role);
                if (roleDetails?.length > 0) {
                    let tempCategoriesL0 = getCategoriesL0ForSPM(roleDetails[0]?.l0)
                    let tempCategoriesL1 = getCategoriesL1ForSPM(roleDetails[0]?.l0)
                    // let tempCategoriesL2 = getCategoriesL2ForSPM(roleDetails[0]?.l0)
                    setCategoriesLevel0(tempCategoriesL0)
                    setCategoryL0Selected(tempCategoriesL0)
                    ////
                    localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategoriesL0))
                    setCategoriesLevel1(tempCategoriesL1)
                    setCategoryL1Selected(tempCategoriesL1)
                    localStorage.setItem('categoryL1Selected', JSON.stringify(tempCategoriesL1))

                    let tempCategoriesL0Selected_array = tempCategoriesL0.map(i => i.displayText)
                    let tempCategoriesL1Selected_array = tempCategoriesL1.map(i => i.displayText)
                    let tempCategoriesL2 = getCategoriesL2ForSmartcube(roleDetails[0]?.l0, tempCategoriesL0Selected_array, tempCategoriesL1Selected_array)

                    setCategoriesLevel2(tempCategoriesL2)
                    setCategoryL2Selected(tempCategoriesL2)
                    localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesL2))
                    spendCardApiCallonChange(val, sectors, BUs, tempCategoriesL0, tempCategoriesL1, tempCategoriesL2, "", "", sectorsToInclude, 2)
                }
            } else {
                let tempCategories = []
                let businessUnitsToInclude = BUs?.map(item => (item.displayText))
                if(countrySwitcherIndex === 1) {
                    const Countries = getCountriesBySectorBuV2(getUserInfoByRole?.sector, sectorsToInclude, businessUnitsToInclude);
                    setCountries(Countries)
                    setCountriesSelected(Countries)
                    localStorage.setItem('countriesSelected', JSON.stringify(Countries))

                    tempCategories = getCategoryL0ListV2(getUserInfoByRole?.category)
                    // const l0dropdown = allCategoryL0 ? formatIntoDropdownData(categoriesToInclude, tempCategories) : []
                    // const result = l0dropdown.filter(item =>
                    //     landingPageFilters?.l0sSelected.some(selected => selected.displayText === item.displayText)
                    // );
                    setCategoriesLevel0(tempCategories)

                    setCategoryL0Selected(tempCategories)
                    localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                }
                else if (countrySwitcherIndex === 0) {
                    // businessUnitsToInclude = BUs?.map(item => (item.displayText))
                    tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "", 3)
                    setCategoriesLevel0(tempCategories)
                    setCategoryL0Selected(tempCategories)
                    localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                }
                // let businessUnitsToInclude = BUs?.map(item => (item.displayText))
                // let tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "", 3)

                /************ Commented OLD LOGIC to maintain category selection ****************************/
                // let tempCategoriesToInclude = tempCategories?.map(item => (item.displayText))
                // const l0dropdown = allCategoryL0 ? formatIntoDropdownData(tempCategoriesToInclude, allCategoryL0) : []
                // setCategoriesLevel0(l0dropdown)
                // const result = l0dropdown.filter(item =>
                //     categoryL0Selected.some(selected => selected.id === item.id)
                // );
                // setCategoryL0Selected(result)
                // if (result.length == 0) {
                //     message.warning("select category L0")
                // }

                // let categoriesToInclude = result?.map(item => (item.displayText))
                // const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "")
                // setCategoriesLevel1(tempCategoriesLevel1)
                // setCategoryL1Selected(tempCategoriesLevel1)

                // let categoriesL1ToInclude = tempCategoriesLevel1?.map(item => (item.displayText))
                // const tempCategoriesLevel2 = getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
                // setCategoriesLevel2(tempCategoriesLevel2);
                // setCategoryL2Selected(tempCategoriesLevel2);
                /************** OLD LOGIC Ends ***********************/

                /********** NEW REVERTED LOGIC For Category Selection *****/
                
                // setCategoriesLevel0(tempCategories)
                // setCategoryL0Selected(tempCategories)
                ////
                // localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                let categoriesToInclude = tempCategories.map(item => (item.displayText))
                const tempCategoriesLevel1 = countrySwitcherIndex == 0 ? getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL1ListV2(getUserInfoByRole?.category, categoriesToInclude)
                setCategoriesLevel1(tempCategoriesLevel1)
                setCategoryL1Selected(tempCategoriesLevel1)
                localStorage.setItem('categoryL1Selected', JSON.stringify(tempCategoriesLevel1))
                let categoriesL1ToInclude = tempCategoriesLevel1.map(item => (item.displayText))
                const tempCategoriesLevel2 = countrySwitcherIndex == 0 ? getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL2ListV2(getUserInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
                setCategoriesLevel2(tempCategoriesLevel2);
                setCategoryL2Selected(tempCategoriesLevel2);
                localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesLevel2))
                /************* NEW LOGIC Ends *********************/

                /*********** Commented OLD LOGIC to maintain category selection *********************/
                // spendCardApiCallonChange(val, sectors, BUs, result, tempCategoriesLevel1, tempCategoriesLevel2, fromDateSelected, toDateSelected, sectorsToInclude, 4)
                /************** OLD LOGIC Ends ***********************/

                /********** NEW REVERTED LOGIC For Category Selection *****/
                spendCardApiCallonChange(val, sectors, BUs, tempCategories, tempCategoriesLevel1, tempCategoriesLevel2, fromDateSelected, toDateSelected, sectorsToInclude, 4)
                /************** OLD LOGIC Ends ***********************/

                // spendCardApiCallonChange(sectors, BUs, categoryL0Selected, categoryL1Selected, categoryL2Selected, fromDateSelected, toDateSelected, sectorsToInclude)
            }
        }
    };

    const onSectorChange = (val) => {
        if (val && val.length > 0) {
            
            setSectorSelected(val)
            localStorage.setItem("sectorSelected", JSON.stringify(val))
            dispatch(setKeyValue({ key: localStoreKeys.sectorSelectedOnDetail, value: val }))
            setLoader(true)

            //update business units when sector changes
            let sectorsToInclude = val?.map(item => (item.displayText))
            const BUs = countrySwitcherIndex == 0 ? getBusinessUnitsBySector(userInfoByRole?.roleDetail, sectorsToInclude) : getBusinessUnitsBySectorV2(userInfoByRole?.sector, sectorsToInclude);
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            localStorage.setItem('BUSeleceted', JSON.stringify(BUs))
            
            
            // let businessUnitsToInclude = BUs?.map(item => (item.displayText))
            // let tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "")
            
                let tempCategories = []
                let businessUnitsToInclude = BUs?.map(item => (item.displayText))
                if(countrySwitcherIndex === 1) {
                    const Countries = getCountriesBySectorBuV2(userInfoByRole?.sector, sectorsToInclude, businessUnitsToInclude);
                    setCountries(Countries)
                    setCountriesSelected(Countries)
                    localStorage.setItem('countriesSelected', JSON.stringify(Countries))

                    tempCategories = getCategoryL0ListV2(userInfoByRole?.category)
                    // // const l0dropdown = allCategoryL0 ? formatIntoDropdownData(categoriesToInclude, tempCategories) : []
                    // // const result = l0dropdown.filter(item =>
                    // //     landingPageFilters?.l0sSelected.some(selected => selected.displayText === item.displayText)
                    // // );
                    // setCategoriesLevel0(tempCategories)

                    // setCategoryL0Selected(tempCategories)
                    // localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                }
                else if (countrySwitcherIndex === 0) {
                    // businessUnitsToInclude = BUs?.map(item => (item.displayText))
                    tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "", 3)
                    // setCategoriesLevel0(tempCategories)
                    // setCategoryL0Selected(tempCategories)
                    // localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                }
            // tempCategories = tempCategories.filter(item => item.displayText !== appNames.coman)
            // setCategoriesLevel0(tempCategories)
            // setCategoryL0Selected(tempCategories)

            let categoriesToInclude = tempCategories?.map(item => (item.displayText))
            const tempCategoriesLevel1 = countrySwitcherIndex == 0 ? getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL1ListV2(userInfoByRole?.category, categoriesToInclude)
            // setCategoriesLevel1(tempCategoriesLevel1)
            // setCategoryL1Selected(tempCategoriesLevel1)

            let categoriesL1ToInclude = tempCategoriesLevel1?.map(item => (item.displayText))
            const tempCategoriesLevel2 = countrySwitcherIndex == 0 ? getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL2ListV2(userInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
            // setCategoriesLevel2(tempCategoriesLevel2)
            // setCategoryL2Selected(tempCategoriesLevel2)

            // spendCardApiCallonChange(val, BUs, tempCategories, tempCategoriesLevel1, tempCategoriesLevel2, fromDateSelected, toDateSelected)
            spendCardApiCallonChange(roleSelected, val, BUs, categoryL0Selected, categoryL1Selected, categoryL2Selected, fromDateSelected, toDateSelected, userAccessibleSectorList, 5)
        } else {
            if (val && val.length === 0) {
                setSectorSelected([])
                localStorage.setItem("sectorSelected", JSON.stringify([]))
                setBusinessUnitSelected([])
                localStorage.setItem('BUSeleceted', JSON.stringify([]))
                setCountriesSelected([])
                localStorage.setItem('countriesSelected', JSON.stringify([]))
                // setCategoryL0Selected([])
                // setCategoryL1Selected([])
                // setCategoryL2Selected([])
                message.warning("At least one sector is required")
            }
        }
    }

    const onBusinessUnitChange = (val) => {
        if (val && val.length > 0) {
            if (sectorSelected.length > 0) {
                setBusinessUnitSelected(val)
                localStorage.setItem('BUSeleceted', JSON.stringify(val))
                setLoader(true)
                //update categories when business units changes
                let sectorsToInclude = sectorSelected?.map(item => (item.displayText))
                // let businessUnitsToInclude = val?.map(item => (item.displayText))
                // let tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "")
                
                let tempCategories = []
                let businessUnitsToInclude = val?.map(item => (item.displayText))
                if(countrySwitcherIndex === 1) {
                    const Countries = getCountriesBySectorBuV2(userInfoByRole?.sector, sectorsToInclude, businessUnitsToInclude);
                    setCountries(Countries)
                    setCountriesSelected(Countries)
                    localStorage.setItem('countriesSelected', JSON.stringify(Countries))

                    tempCategories = getCategoryL0ListV2(userInfoByRole?.category)
                    // // const l0dropdown = allCategoryL0 ? formatIntoDropdownData(categoriesToInclude, tempCategories) : []
                    // // const result = l0dropdown.filter(item =>
                    // //     landingPageFilters?.l0sSelected.some(selected => selected.displayText === item.displayText)
                    // // );
                    // setCategoriesLevel0(tempCategories)

                    // setCategoryL0Selected(tempCategories)
                    // localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                }
                else if (countrySwitcherIndex === 0) {
                    // businessUnitsToInclude = val?.map(item => (item.displayText))
                    tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "", 3)
                    // setCategoriesLevel0(tempCategories)
                    // setCategoryL0Selected(tempCategories)
                    // localStorage.setItem('CategoryL0Selected', JSON.stringify(tempCategories))
                }

                // tempCategories = tempCategories.filter(item => item.displayText !== appNames.coman)
                // setCategoriesLevel0(tempCategories)
                // setCategoryL0Selected(tempCategories)

                let categoriesToInclude = tempCategories?.map(item => (item.displayText))
                const tempCategoriesLevel1 = countrySwitcherIndex == 0 ?  getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL1ListV2(userInfoByRole?.category, categoriesToInclude)
                // setCategoriesLevel1(tempCategoriesLevel1)
                // setCategoryL1Selected(tempCategoriesLevel1)

                let categoriesL1ToInclude = tempCategoriesLevel1?.map(item => (item.displayText))
                const tempCategoriesLevel2 = countrySwitcherIndex == 0 ?  getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL2ListV2(userInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
                // setCategoriesLevel2(tempCategoriesLevel2)
                // setCategoryL2Selected(tempCategoriesLevel2)

                // spendCardApiCallonChange(sectorSelected, val, tempCategories, tempCategoriesLevel1, tempCategoriesLevel2, fromDateSelected, toDateSelected)
                spendCardApiCallonChange(roleSelected, sectorSelected, val, categoryL0Selected, categoryL1Selected, categoryL2Selected, fromDateSelected, toDateSelected, userAccessibleSectorList, 6)
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setBusinessUnitSelected([])
                localStorage.setItem('BUSeleceted', JSON.stringify([]))
                setCountriesSelected([])
                localStorage.setItem('countriesSelected', JSON.stringify([]))
                // setCategoryL0Selected([])
                // setCategoryL1Selected([])
                // setCategoryL2Selected([])
                message.warning("At least one business unit / market is required")
            }
        }
    }

    const onCountryChangeV2 = (val) => {
        
        if (val && val.length > 0) {
            if (sectorSelected.length > 0 && businessUnitSelected.length > 0) {
                setCountriesSelected(val)
                localStorage.setItem('countriesSelected', JSON.stringify(val))
                setLoader(true)
                //update categories when business units changes
                // let sectorsToInclude = sectorSelected?.map(item => (item.displayText))
                // let businessUnitsToInclude = val?.map(item => (item.displayText))
                // let tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude, "")
                // tempCategories = tempCategories.filter(item => item.displayText !== appNames.coman)
                // setCategoriesLevel0(tempCategories)
                // setCategoryL0Selected(tempCategories)

                // let categoriesToInclude = tempCategories?.map(item => (item.displayText))
                // const tempCategoriesLevel1 = getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "")
                // setCategoriesLevel1(tempCategoriesLevel1)
                // setCategoryL1Selected(tempCategoriesLevel1)

                // let categoriesL1ToInclude = tempCategoriesLevel1?.map(item => (item.displayText))
                // const tempCategoriesLevel2 = getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "")
                // setCategoriesLevel2(tempCategoriesLevel2)
                // setCategoryL2Selected(tempCategoriesLevel2)

                // spendCardApiCallonChange(sectorSelected, val, tempCategories, tempCategoriesLevel1, tempCategoriesLevel2, fromDateSelected, toDateSelected)
                spendCardApiCallonChange(roleSelected, sectorSelected, val, categoryL0Selected, categoryL1Selected, categoryL2Selected, fromDateSelected, toDateSelected, userAccessibleSectorList, 6)
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                // setBusinessUnitSelected([])
                // localStorage.setItem('BUSeleceted', JSON.stringify([]))
                // setCategoryL0Selected([])
                // setCategoryL1Selected([])
                // setCategoryL2Selected([])
                setCountriesSelected([])
                localStorage.setItem('countriesSelected', JSON.stringify([]))
                message.warning("At least one country is required")
            }
        }
    }

    

    const onCategoryLevel0Change = (val) => {
        let sectorSelectedData = localStorage.getItem('sectorSelected')
        sectorSelectedData = JSON.parse(sectorSelectedData)
        let businessUnitSelectedData = JSON.parse(localStorage.getItem('BUSeleceted'))
        let countriesSelectedData = JSON.parse(localStorage.getItem('countriesSelected'))
        if (val && val.length > 0) {
            if (sectorSelectedData.length > 0) {
                if (businessUnitSelectedData.length > 0) {
                    if (countrySwitcherIndex !== 1 || countriesSelectedData?.length > 0) { // Check only if countrySwitcherIndex is 1 and country data  > 0
                        setCategoryL0Selected(val)
                        //
                        localStorage.setItem('CategoryL0Selected', JSON.stringify(val))
                        setLoader(true)
                        let sectorsToInclude = sectorSelectedData?.map(item => (item.displayText))
                        let businessUnitsToInclude = businessUnitSelectedData?.map(item => (item.displayText))
                        let categoriesToInclude = val?.map(item => (item.displayText))

                        if (capability === appNames.marketIntel && appName == "SmartCube") {
                            const defaultRole = roleSelected[0]['displayText']
                            const roleDetails = smartcubeCategories?.data?.filter(item => defaultRole === item.role);
                            if (roleDetails?.length > 0) {
                                let tempCategoriesL1 = getCategoriesL1ForSmartcube(roleDetails[0]?.l0, categoriesToInclude)
                                let categoriesL1ToInclude = tempCategoriesL1?.map(item => (item.displayText))
                                let tempCategoriesL2 = getCategoriesL2ForSmartcube(roleDetails[0]?.l0, categoriesToInclude, categoriesL1ToInclude)
                                setCategoriesLevel1(tempCategoriesL1)
                                setCategoryL1Selected(tempCategoriesL1)
                                localStorage.setItem('categoryL1Selected', JSON.stringify(tempCategoriesL1))
                                setCategoriesLevel2(tempCategoriesL2)
                                setCategoryL2Selected(tempCategoriesL2)
                                localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesL2))
                                spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, val, tempCategoriesL1, tempCategoriesL2, "", "", userAccessibleSectorList, 7)
                            }
                        } else {
                            const tempCategoriesLevel1 = countrySwitcherIndex == 0 ?  getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, "") : getCategoryL1ListV2(userInfoByRole?.category, categoriesToInclude)
                            setCategoriesLevel1(tempCategoriesLevel1)
                            setCategoryL1Selected(tempCategoriesLevel1)
                            localStorage.setItem('categoryL1Selected', JSON.stringify(tempCategoriesLevel1))
                            let categoriesL1ToInclude = tempCategoriesLevel1?.map(item => (item.displayText))
                            const tempCategoriesLevel2 = countrySwitcherIndex == 0 ?  getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, ""): getCategoryL2ListV2(userInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
                            setCategoriesLevel2(tempCategoriesLevel2)
                            setCategoryL2Selected(tempCategoriesLevel2)
                            localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesLevel2))
                            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, val, tempCategoriesLevel1, tempCategoriesLevel2, fromDateSelected, toDateSelected, userAccessibleSectorList, 8)
                        }
                    } else {
                        message.warning("Please select at least one country")
                    }
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL0Selected([])
                ////
                localStorage.setItem('CategoryL0Selected', JSON.stringify([]))
                setCategoryL1Selected([])
                localStorage.setItem('categoryL1Selected', JSON.stringify([]))
                setCategoryL2Selected([])
                localStorage.setItem('categoryL2Selected', JSON.stringify([]))
                message.warning("At least one category L0 is required")
            }
        }
    }

    const onCategoryLevel1Change = (val) => {
        if (val && val.length > 0) {
            if (sectorSelected.length > 0) {
                if (businessUnitSelected.length > 0) {
                    if(countrySwitcherIndex !== 1 || countriesSelected.length > 0){ // Check only if countrySwitcherIndex is 1 and country data  > 0
                    if (categoryL0Selected.length > 0) {
                        setCategoryL1Selected(val)
                        localStorage.setItem('categoryL1Selected', JSON.stringify(val))
                        setLoader(true)
                        let sectorsToInclude = sectorSelected?.map(item => (item.displayText))
                        let businessUnitsToInclude = businessUnitSelected?.map(item => (item.displayText))
                        let categoriesToInclude = categoryL0Selected?.map(item => (item.displayText))
                        let categoriesL1ToInclude = val?.map(item => (item.displayText))
                        if (capability === appNames.marketIntel && appName == "SmartCube") {
                            const defaultRole = roleSelected[0]['displayText']
                            const roleDetails = smartcubeCategories?.data?.filter(item => defaultRole === item.role);
                            if (roleDetails?.length > 0) {
                                let tempCategoriesL2 = getCategoriesL2ForSmartcube(roleDetails[0]?.l0, categoriesToInclude, categoriesL1ToInclude)
                                setCategoriesLevel2(tempCategoriesL2)
                                setCategoryL2Selected(tempCategoriesL2)
                                localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesL2))
                                spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, val, tempCategoriesL2, "", "", userAccessibleSectorList, 9)
                            }
                        } else {
                            const tempCategoriesLevel2 = countrySwitcherIndex == 0 ?  getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, ""): getCategoryL2ListV2(userInfoByRole?.category, categoriesToInclude, categoriesL1ToInclude)
                            setCategoriesLevel2(tempCategoriesLevel2)
                            setCategoryL2Selected(tempCategoriesLevel2)
                            localStorage.setItem('categoryL2Selected', JSON.stringify(tempCategoriesLevel2))
                            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, val, tempCategoriesLevel2, fromDateSelected, toDateSelected, userAccessibleSectorList, 10)
                        }
                    } else {
                        message.warning("Please select at least one category 0")
                    }
                } else{
                        message.warning("Please select at least one country")
                }
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL1Selected([])
                localStorage.setItem('categoryL1Selected', JSON.stringify([]))
                setCategoryL2Selected([])
                localStorage.setItem('categoryL2Selected', JSON.stringify([]))
                
                if (capability === appNames.archlet || capability === appNames.compass || capability === appNames.r2pInsights || capability === appNames.powersteering) {
                    message.warning("At least one category L1 is required")
                }
            }
        }
    }

    
    const onCategoryLevel2Change = (val) => {
        if (val && val.length > 0) {
            if (sectorSelected.length > 0) {
                if (businessUnitSelected.length > 0) {
                    if(countrySwitcherIndex !== 1 || countriesSelected.length > 0){ // Check only if countrySwitcherIndex is 1 and country data  > 0
                    if (categoryL0Selected.length > 0) {
                        if (categoryL1Selected.length > 0) {
                            setCategoryL2Selected(val)
                            localStorage.setItem('categoryL2Selected', JSON.stringify(val))
                            setLoader(true)
                            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, val, fromDateSelected, toDateSelected, userAccessibleSectorList, 12)
                        } else {
                            message.warning("Please select at least one category 1")
                        }
                    } else {
                        message.warning("Please select at least one category 0")
                    }
                } else{
                    message.warning("Please select at least one country")
                }
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL2Selected([])
                localStorage.setItem('categoryL2Selected', JSON.stringify([]))
                
                if (capability === appNames.archlet || capability === appNames.compass || capability === appNames.r2pInsights) {
                    message.warning("At least one category L2 is required")
                }
            }
        }
    }

    
    const onFromDateChange = (val) => {
        let sectorSelectedData = localStorage.getItem('sectorSelected')
        // if(sectorSelectedData){
            sectorSelectedData = JSON.parse(sectorSelectedData)
        // }
        //
        let businessUnitSelectedData = JSON.parse(localStorage.getItem('BUSeleceted'))
        let categoryL0SelectedData = JSON.parse(localStorage.getItem('CategoryL0Selected'))
        let categoryL1SelectedData = JSON.parse(localStorage.getItem('categoryL1Selected'))
        let categoryL2SelectedData = JSON.parse(localStorage.getItem('categoryL2Selected'))
        let fromDateSelectedData = JSON.parse(localStorage.getItem('fromDateSelected'))
        let toDateSelectedData = JSON.parse(localStorage.getItem('toDateSelected'))

        // console.log("resData", categoryL0SelectedData)
        if (val && val.length > 0) {
            if (capability === appNames.powersteering) {
                setFromDateSelected(val)
                localStorage.setItem('fromDateSelected', JSON.stringify(val))
                let sectorsToInclude = sectorSelectedData?.map(item => (item.displayText ? item.displayText : item))
                spendCardApiCallonChange(roleSelected, sectorSelectedData, businessUnitSelectedData, categoryL0SelectedData, categoryL1SelectedData, categoryL2SelectedData, val, "", sectorsToInclude, 18)
                // spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, categoryL2Selected, val, "", userAccessibleSectorList, 18)
            } else {
                setFromDateSelected(val)
                localStorage.setItem('fromDateSelected', JSON.stringify(val))
                dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: val[0]['displayText'] }));
                const toDateOptions = getToDateOptions(val[0]['displayText']); // TO BE CHANGED
                // setToDates(toDateOptions); OLD LOGIC

                let capabilitySearchKey = getCapabilitySearchKey(appName,capability);
                const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);
                const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]['displayText'], maxDateObject);
                setToDates(toDateOptions1);

                let tempY = val[0]['displayText']?.split(" ")?.[1]
                const date1 = new Date(val[0]['displayText']);
                const date2 = new Date(toDateSelected?.[0]?.['displayText']);
                const date2Year = date2?.getFullYear();
                const toDateMonth = months[date2?.getMonth()];;

                const tempToDate = toDateOptions1?.filter((item) => { // CHANGED
                    return item.displayText === ('Dec ' + tempY);
                })

                const customTempToDate = toDateOptions1?.filter((item) => { // CHANGED
                    return item.displayText === (`${toDateMonth} ` + date2Year);
                })
                changeToDateOptions(val[0])

                if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
                    if (date1 <= date2) {
                        setToDateSelected(customTempToDate); 
                        localStorage.setItem('toDateSelected', JSON.stringify(customTempToDate))
                        spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, categoryL2Selected, val, customTempToDate, userAccessibleSectorList, 14)
                    } else {
                        setToDateSelected(tempToDate);
                        localStorage.setItem('toDateSelected', JSON.stringify(tempToDate))
                        spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, categoryL2Selected, val, tempToDate, userAccessibleSectorList, 15)
                    }
                } else {
                    spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, categoryL2Selected, val, tempToDate, userAccessibleSectorList, 16)
                }
            }
        } else {
            message.warning("From Date is not selected")
        }
    }

    
    const onToDateChange = (val) => {
        // console.log("val");

        if (val && val.length > 0) {
            setToDateSelected(val)
            localStorage.setItem('toDateSelected', JSON.stringify(val))
            changeFromDateOptions(val[0]);
            ////
            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, categoryL2Selected, fromDateSelected, val, userAccessibleSectorList, 17)
        } else {
            message.warning("To Date is not selected")
        }
    }

    
    const changeFromDateOptions = (toDateMonthSelected) => {
        /* const toDateSelected = toDateMonthSelected.displayText;
        const maxDate = new Date(toDateSelected);
        const filteredMonths = entireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate <= maxDate;
        });
        filteredMonths.push(toDateMonthSelected);
        filteredMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
		*/
		const filteredMonths = changeFromDateOptionsUtil(toDateMonthSelected,entireMonthList)
        setFromDates(filteredMonths)
    }
	
	
	
    
    const changeToDateOptions = (fromDateMonthSelected) => {
        /* const toDateSelected1 = fromDateMonthSelected.displayText;
        const fromDate = new Date(toDateSelected1);
        const filteredMonths = entireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate >= fromDate;
        });*/
		const filteredMonths = changeToDateOptionsUtil(fromDateMonthSelected,entireMonthList)
        setToDates(filteredMonths);
    };

    
    const onMonthYearChange = (val) => {
        if (val && val.length > 0) {
            setMonthYearDate(val)
        } else {
            message.warning("month/year is required")
        }
    }

    
    
    const onFiltersReset = () => {
        // let capabilitySearchKey = appName === "In-house MI Team" ? appName : capability;
        let capabilitySearchKey = getCapabilitySearchKey(appName,capability);
        const minYear = atob(localStorage.getItem("minYear"));
        const maxYear = atob(localStorage.getItem("maxYear"));

        setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));
        const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

        let years = userData?.year?.slice();
        let compassMonthLists = generateMonthsList(years, maxDateObject)
        
        setCompassMonthList(compassMonthLists)

        const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
        // setFromDates(fromDate);

        let yearSelected = localStorage.getItem("yearSelected");
        const allYears = landingPageFilters?.allYears
        let yearVal = allYears
        if (defaultYear !== "-") {
            // Placing 2025 as default year ( on reset ) for Veridion (V) capability as the veridion data is limited to 2025.
            if(capabilitySearchKey == "Veridion (V)"){
                yearSelected = VERIDION_DEFAULT_YEAR
            } else{
                yearSelected = defaultYear;
            }
            yearVal = formatIntoDropdownData([Number(defaultYear)], allYears)
        }

        const date2 = new Date();
        const date2Year = date2.getFullYear();

        const fromDateMonth = capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`) ?
             'Dec' : 
             capability === appNames.compass? // && date2Year === Number(yearSelected) ? 
                maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'
        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })

        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);
        let maxYearMonth = maxDateObject?.maxYearMonth;
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setToDates(toDateOptions);

        if (capability === appNames.powersteering) { 
            setFromDateSelected(yearVal) // landingPageFilters.year
            localStorage.setItem('fromDateSelected', JSON.stringify(yearVal)) // landingPageFilters.year
        } else {
            setFromDateSelected(tempFromDate);
            localStorage.setItem('fromDateSelected', JSON.stringify(tempFromDate))
        }
        dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: tempFromDate?.[0]?.['displayText'] }));
        setToDateSelected(tempToDate);
        localStorage.setItem('toDateSelected', JSON.stringify(tempToDate))
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }
        
        onRoleChange(roleSelected)
    }

    // console.log("sectorSelected", sectorSelected)

    
    return (
        <>
            {/* <div style={{margin: '10px 0'}}>
                <div style={{fontFamily: "Inter", fontSize: "0.75rem", margin: '3px'}}>View By</div>
                <div style={{width: '25%'}}>
                    <Switcher
                        className=""
                        items={[
                            {
                            label: 'Sector BU',
                            leadingIcon: 'edit',
                            showLeadingIcon: false,
                            style: {width: '50%', display: 'flex', justifyContent: 'center'}
                            },
                            {
                            label: 'Sector BU Country',
                            leadingIcon: 'edit',
                            showLeadingIcon: false,
                            style: {width: '50%', display: 'flex', justifyContent: 'center'}
                            }
                        ]}
                        // selectedItemIndex={countrySwitcherIndex}
                        // onUpdate= {(val) => {
                        //     switchTabs(val)
                        // }}
                        style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
                    />
                </div>
            </div> */}
            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                
                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                    <SingleSelectDropdown placeholder="Views" className='buy-con-dropdown-modal ph-view-dropdown' label="View" childList={allRoles} selectedValue={roleSelected} setSelectedValue={onRoleChange} />
                </Col>
                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                    <MultiSelectDropdown placeholder="Sectors" className='buy-con-dropdown-modal' label="Sector" childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange} />
                </Col>
                {
                    appName === "In-house MI Team" ? null :
                        <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                            <MultiSelectDropdown placeholder="BUs" className='buy-con-dropdown-modal' label="Business Unit / Market" childList={businessUnits} selectedValue={businessUnitSelected} setSelectedValue={onBusinessUnitChange} />
                        </Col>
                }
                {
                    countrySwitcherIndex === 1 &&  (
                        <>
                            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                <MultiSelectDropdown placeholder="Country" className='buy-con-dropdown-modal' label="Country" childList={countries} selectedValue={countriesSelected} setSelectedValue={onCountryChangeV2} />
                            </Col>
                        </>
                    )
                }
                {
                    capability !== appNames.coman ?
                        <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                            <MultiSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' label="Category L0" childList={categoriesLevel0} selectedValue={categoryL0Selected} setSelectedValue={onCategoryLevel0Change} />
                        </Col> :
                        <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                            <SingleSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' label="Category L0" childList={coManL0Category} selectedValue={coManL0Category} setSelectedValue={setCategoryL0Selected} />
                        </Col>
                }
                {
                    capability !== appNames.coman &&
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <MultiSelectDropdown placeholder="Categories L1" className='buy-con-dropdown-modal' label="Category L1" childList={categoriesLevel1} selectedValue={categoryL1Selected} setSelectedValue={onCategoryLevel1Change} />
                        {capability === appNames.powersteering && <InfoIcon style={{ position: 'absolute', top: 0, left: '60%' }} text="L2 classification is WIP by taxonomy harmonisation team" />}
                    </Col>
                }
                {
                    capability !== appNames.coman && capability !== appNames.powersteering  && appName!=="Forestreet (F)" 
                    && selectedTab!==1 && // capability !== appNames.forestreet &&
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <MultiSelectDropdown placeholder={(capability !== appNames.marketIntel || appName == "In-house MI Team") ? "Category L2" : "Mapped SmartCube Category"} className='buy-con-dropdown-modal' label={(capability !== appNames.marketIntel || appName == "In-house MI Team") ? "Category L2" : "Mapped SmartCube Category"} childList={categoriesLevel2} selectedValue={categoryL2Selected} setSelectedValue={onCategoryLevel2Change} />
                    </Col>
                }
                {
                    (capability !== appNames.marketIntel || appName == "In-house MI Team") && ![appNames.contract].includes(capability) 
                    && selectedTab!=2 &&
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        {
                            capability === appNames.powersteering ?
                                <SingleSelectDropdown
                                    className='buy-con-dropdown-modal'
                                    label={"Year"}
                                    childList={landingPageFilters?.allYears}
                                    selectedValue={fromDateSelected}
                                    setSelectedValue={onFromDateChange}
                                />
                                :
                                <SingleSelectDropdown
                                    className='buy-con-dropdown-modal'
                                    label={capability === appNames.compass ? "Month/Year" : "From Date"}
                                    childList={capability === appNames.compass ? compassMonthList : fromDates}
                                    selectedValue={fromDateSelected}
                                    setSelectedValue={onFromDateChange}
                                    disabled={capability===appNames.forestreet && appName==="Veridion (V)" && selectedTab==2}
                                />
                        }
                    </Col>
                }
                {
                    (capability !== appNames.marketIntel || appName == "In-house MI Team") 
                    && ![appNames.compass, appNames.powersteering, appNames.contract].includes(capability)
                    && selectedTab!=2 &&
                    // && ![appNames.compass, appNames.powersteering, appNames.forestreet].includes(capability) &&
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <SingleSelectDropdown className='buy-con-dropdown-modal' 
                            label="To Date" 
                            childList={toDates} 
                            selectedValue={toDateSelected} 
                            setSelectedValue={onToDateChange}
                            disabled={capability===appNames.forestreet && appName==="Veridion (V)" && selectedTab==2} />
                    </Col>
                }
                {/* {
                    capability === appNames.compass &&
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <SingleSelectDropdown className='buy-con-dropdown-modal' label="Month/Year" childList={entireMonthList} selectedValue={monthYearDate} setSelectedValue={onMonthYearChange} />
                    </Col>
                } */}
                
            </Row>
            <Row justify="end">
                    <button className="reset-button" onClick={onFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem' }}>
                        <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                        <span style={{width: '100%'}}>Reset Filters</span>
                    </button>
            </Row>
            {/* <Button 
                        className=""
                        size="small"
                        style={{}}
                        text="Reset Filters"
                        variant="tertiary"
                        iconLeading='undo'
                        onClick={onFiltersReset}>
            </Button> */}
            {/* {
            appNames.contract == capability &&
            <div style={{display:"flex"}}> 
                <Icon alt="" icon="info" size="small"/>
                <div className="landing_page_process_overview" style={{ color: '#3A3A3A', fontSize: 16 }}>
                {(() => {
                            const mergedCategories = [...selectedBlankL0Categories, ...selectedBlankL1Categories];
                            return mergedCategories.length > 0
                            ? `For the category selection: [${mergedCategories.join(", ")}], the data is not displayed at sub-category level`
                            : "";
                        })()}
                </div>
            </div>
        } */}
        </>
    )
}

export default ModalFilters